import { abbreviateNumber, isFeatureTogglesOn } from '@glow/common'
import { userLanguage } from '@glow/common/utils/language'
import { BannerIdType, ConsignmentState, WhatsThisModalIdType } from '@glow/entity-types'
import { UploadFile } from '@glow/ui-components'
import { saveAs } from 'file-saver'
import i18next from 'i18next'
import Immutable, { fromJS, List, Map, Set } from 'immutable'
import toString from 'lodash-es/toString'
import { DateTime, Duration } from 'luxon'
import React from 'react'
import { CustomerHDOrderInvoiceFromDatePayload } from '../../components/CustomerInvoiceHDOrdersFromDateModal'
import { CustomerSenderNameProps } from '../../components/CustomerSenderNameModal'
import { DeliveryTime } from '../../components/newShipmentModal/shared/Shipment'
import { UnitFormProps } from '../../components/unit/UnitForm'
import { CustomerIdType } from '../../domain/customer'
import { MainAccessEntity } from '../../domain/mainAccessType'
import { UnresolvedAddressIdType } from '../../domain/unresolvedAddress'
import { api, asyncOptimusCreateOrders, ConsumedResponse, checkoutApi, QueryData } from '../../http/httpHelper'
import { CustomerEventEmailFormProps } from '../../pages/admin/CustomerEventEmailModal'
import { ProductionTimeWindowForm } from '../../pages/admin/productionTimeWindow/NewProductionTimeWindowModal'
import { EditProductionTimeWindowFormValues } from '../../pages/admin/productionTimeWindow/ProductionTimeWindowResults'
import { SearchProductionTimeWindowsParams } from '../../pages/admin/productionTimeWindow/utils'
import { UserRolesPayload } from '../../pages/admin/user-roles/utils'
import { CreateBannerPayload, UpdateBannerPayload } from '../../pages/cms/bannerUtils'
import { CMSNewsIdType, CreateCMSNewsPayload, UpdateCMSNewsPayload } from '../../pages/cms/CMSNewsUtils'
import { CreateWhatsThisModalPayload, UpdateWhatsThisModalPayload } from '../../pages/cms/modalUtils'
import { customerNumberAndSubcustomer } from '../../pages/instant/bookingOrderFunctions'
import { CorrectedArticlePrice, IPricedArticle } from '../../pages/instant/bookingOrderTypes'
import { UnitSuggestionType } from '../../pages/instant/SuggestedUnits'
import { CreateUpdateCourierFormProps } from '../../pages/planner/courier/courierPageProps'
import { BillingOrder } from '../../pages/planner/page-billing-order/billingOrder'
import { DateParams } from '../../pages/planner/pickup-orders/PickupOrders'
import { TemplateRoute } from '../../pages/planner/recurring/recurringOrderTypes'
import {
  SearchParams as ShipmentSearchParams,
  WITHOUT_DELIVERY_DATE
} from '../../pages/shipments/search-page/ShipmentSearchTypes'
import { httpDone } from '../../reducers/httpStatus'
import {
  ConsignmentIdType,
  CourierUserId,
  CustomerGroup,
  CustomerGroupIdType,
  DepartmentFormValues,
  DepartmentGroupIdType,
  DepartmentGroupProps,
  DepartmentIdType,
  ISODateString,
  OrderIdType,
  PlannedStopLocationProps,
  PlannerProps,
  RoleId,
  RoutePostalCodeRuleProps,
  SessionUser,
  Slot,
  SlotIdType,
  UnitIdType,
  VehicleIdType
} from '../../types/coreEntitiesTypes'
import { ImmutableMap } from '../../types/immutableTypes'
import { isNotEmpty } from '../../utils/collectionUtils'
import { formatAsLocalDate } from '../../utils/dateTime'
import { getSelectedOptimizingType } from '../../utils/optimizingUtils'
import { ROLE_READ_ONLY_PLANNER } from '../../utils/roles'
import { ServiceVasText } from '../../utils/serviceUtils'
import {
  ACCEPT_ORDERS,
  ActionType,
  ADD_NEW_PRODUCTION_TIME_WINDOW,
  ADD_READY_FOR_PICKUP_EVENTS,
  ADD_ROLES_TO_USER,
  ADD_SCANNED_EVENTS,
  ADD_SORTED_EVENTS,
  ADD_TEMPLATE_ROUTE_RULE,
  ADD_TEXT,
  ADD_UPDATE_SERVICE_MAPPING,
  ADD_UPSALES_RULE,
  ASSIGN_COURIER_TO_SLOT,
  ASSIGN_UNIT_TO_SLOT,
  ASSIGN_VEHICLE_TO_SLOT,
  AUTOSUGGEST_CUSTOMERS,
  AVAILABLE_DELIVERY_TIMES_ADD,
  BATCH_CONSIGNMENT_FETCH,
  CANCEL_RUNNING_OPTIMIZING,
  CLAIM_EMAIL,
  CLEAR_ALL_ENTITIES,
  CLEAR_ALL_HTTP_STATUS,
  CLEAR_APOLLO_AUDIT_LOG,
  CLEAR_ENTITIES,
  CLEAR_ENTITY_COMMAND_RESULT,
  CLEAR_HTTP_STATUS,
  CLEAR_LOCAL_PLANNER_ENTITIES,
  CLEAR_OPTIMIZING_DATA,
  CLEAR_ORDER_IDS_ON_MOVED_ORDERS,
  CLEAR_ORDER_SEARCHS,
  CLEAR_SEARCH_ADDRESSES,
  CLEAR_SEARCH_CUSTOMERS,
  COLLECT_CONSIGNMENTS_MANUAL_OVERRIDE,
  COMPLETE_SLOT_PLANNING,
  CONNECT_ROUTE_TO_TEMPLATE_ROUTE_RULE,
  CONNECT_UNITS_TO_VENDOR_SITE,
  COPY_DEVIATED_ORDER,
  CREATE_BANNER,
  CREATE_BILLING_ORDER,
  CREATE_CMS_NEWS,
  CREATE_COURIER_USER,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_GROUP,
  CREATE_DELIVERY_LABELS,
  CREATE_DEPARTMENT,
  CREATE_DEPARTMENT_GROUP,
  CREATE_HOLIDAY,
  CREATE_LABEL,
  CREATE_LABELS_FOR_DEPARTMENT,
  CREATE_MULTILEG_RETURN,
  CREATE_MULTILEG_RETURNS,
  CREATE_MULTIPLE_LABEL,
  CREATE_NUMBER_SERIES,
  CREATE_OR_UPDATE_TEMPLATE,
  CREATE_ORDER_DEVIATION,
  CREATE_ORDER_OPTIMUS,
  CREATE_PLANNER,
  CREATE_PRE_ADVICE_POLICY,
  CREATE_RETURN_LABELS,
  CREATE_ROLE,
  CREATE_ROUTE,
  CREATE_ROUTE_LABEL,
  CREATE_SLOTS_FROM_TEMPLATE,
  CREATE_UNIT,
  CREATE_UPDATE_CUSTOMER_SMS_TEXT,
  CREATE_VEHICLE,
  CREATE_WAYBILLS_REQUEST,
  CREATE_WHATS_THIS_MODAL,
  DELETE_BANNER,
  DELETE_BREAK_FROM_ROUTE,
  DELETE_CMS_NEWS,
  DELETE_CUSTOMER_GROUP,
  DELETE_DEPARTMENT_GROUP,
  DELETE_HOLIDAY,
  DELETE_NUMBER_SERIES,
  DELETE_ORDER_DEVIATION,
  DELETE_ORDERS,
  DELETE_PRE_ADVICE_POLICY,
  DELETE_PRODUCTION_TIME_WINDOW,
  DELETE_ROLE,
  DELETE_ROUTE_LABEL,
  DELETE_SERVICE_MAPPING,
  DELETE_SLOT,
  DELETE_TEMPLATE,
  DELETE_TEMPLATE_ROUTE,
  DELETE_TEMPLATE_ROUTE_RULE,
  DELETE_TEMPLATE_ROUTES,
  DELETE_TEXT,
  DELETE_TIME_MATRIX,
  DELETE_UPSALES_RULE,
  DELETE_USER,
  DELETE_WHATS_THIS_MODAL,
  DELIVER_CONSIGNMENT_MANUAL_OVERRIDE,
  DEVIATE_CONSIGNMENT_MANUAL_OVERRIDE,
  DISABLE_JOB,
  DISABLE_UPSALES_RULE,
  DISMISS_RECURRING_ROUTE_PROBLEMS,
  DRAWER_CLOSE,
  DRAWER_OPEN,
  EDIT_PRODUCTION_TIME_WINDOW,
  ENABLE_JOB,
  ENABLE_UPSALES_RULE,
  EVENTS_WITH_SENT_LM_STATUS,
  EXECUTE_RECURRING_ROUTES,
  FORCE_UNASSIGN_CONSIGNMENTS,
  GET_ALL_BANNERS,
  GET_ALL_CMS_NEWS,
  GET_ALL_CUSTOMERS,
  GET_ALL_DEPARTMENT_GROUPS,
  GET_ALL_DEPARTMENTS,
  GET_ALL_WHATS_THIS_MODALS,
  GET_APOLLO_AUDIT_LOG,
  GET_APOLLO_AUDIT_LOG_DETAILS,
  GET_ARTICLES,
  GET_ARTICLES_IN_GROUP,
  GET_BANNER_BY_ID,
  GET_BILLING_ORDER_PRICE_DATA,
  GET_CMS_NEWS_BY_ID,
  GET_CONSIGNMENTS,
  GET_CONSIGNMENTS_IN_SAME_LOAD_CARRIER,
  GET_COURIER_LOCATIONS,
  GET_CUSTOMER_CURRENCY,
  GET_CUSTOMER_EVENT_EMAIL,
  GET_CUSTOMER_EXTERNAL_CUSTOMER_NUMBERS,
  GET_CUSTOMER_GROUP_MEMBERS,
  GET_CUSTOMER_GROUPS,
  GET_CUSTOMER_INVOICE_SPLIT,
  GET_CUSTOMER_MIGRATION_STATUS,
  GET_CUSTOMER_RETURN_ADDRESS,
  GET_CUSTOMER_SMS_TEXT,
  GET_CUSTOMERS_WITH_TIME_MATRIX,
  GET_DELIVERY_NOTES,
  GET_DELIVERY_WINDOWS,
  GET_DEPARTMENT_GROUP_REGION_ID,
  GET_DEPARTMENT_GROUPS,
  GET_DEPARTMENT_TIME_WINDOWS,
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_IN_SAME_COUNTRY,
  GET_DRIVER_FOR_SLOT,
  GET_HOLIDAYS_DATA,
  GET_IMPORT_RESULTS,
  GET_IMPORT_STATUS,
  GET_INVOICED_ORDER_PRICE_DATA,
  GET_INVOICING_DATA,
  GET_JOBS_STATUS,
  GET_LATEST_OPTIMIZING_ID_BY_SLOT,
  GET_LATEST_PRICE_UPDATE,
  GET_LOGIN_PAGE_BANNER,
  GET_MULTILEG_ORDER_PRICE_DATA,
  GET_MULTIPLE_LABEL,
  GET_MULTISTOP_ORDER_PRICE_DATA,
  GET_NUMBER_SERIES,
  GET_OPTIMIZE_REQUEST,
  GET_OPTIMIZING_DATA,
  GET_OPTIMIZING_ERROR_DATA,
  GET_OPTIMIZING_REQUEST_DATA,
  GET_OPTIMIZING_RESPONSE_DATA,
  GET_ORDER_BY_SHIPMENT_ID,
  GET_ORDER_CORRECTIONS,
  GET_ORDER_DEVIATIONS,
  GET_ORDER_PRICE_DATA,
  GET_ORDER_RETURN_DETAILS,
  GET_ORDERS_BY_ORDER_IDS,
  GET_ORDERS_BY_RECURRING_ORDER_ID,
  GET_PLANNED_STOP_LOCATIONS,
  GET_PLANNED_STOPS_FOR_SLOT,
  GET_PRE_ADVICE,
  GET_PRE_ADVICE_POLICIES,
  GET_PRE_ADVICE_SERVICE_POLICIES,
  GET_PUBLISHED_BANNERS,
  GET_PUBLISHED_CMS_NEWS,
  GET_PUBLISHED_WHATS_THIS_MODALS,
  GET_RECURRING_ORDER_EXECUTIONS,
  GET_ROUTE_LABELS,
  GET_ROUTE_POINTS,
  GET_ROUTE_POSTAL_CODE_RULES,
  GET_SERVICE_MAPPING_DATA,
  GET_SERVICES_AND_VASES_TEXTS,
  GET_SLOT,
  GET_SLOT_ANY_DEPARTMENT,
  GET_SLOTS,
  GET_SLOTS_BY_UNIT_ID,
  GET_SUBCUSTOMERS,
  GET_SUGGESTED_UNITS_FOR_LOCATION,
  GET_SUGGESTED_UNITS_ON_DELIVERY,
  GET_SUGGESTED_UNITS_ON_PICKUP,
  GET_TEMPLATE_ROUTE_RULE_BY_ID,
  GET_TEMPLATE_ROUTE_RULES,
  GET_TEMPLATES,
  GET_TEXT_BY_ID,
  GET_TEXTS,
  GET_UNASSIGNED_CONSIGNMENT_EVENTS,
  GET_UNCONFIRMED_ORDERS,
  GET_UNCONFIRMED_ORDERS_COUNT,
  GET_UNITS,
  GET_UNRESOLVED_ADDRESS_COUNT,
  GET_UNRESOLVED_ADDRESSES,
  GET_UPSALES_RULE_BY_ID,
  GET_UPSALES_RULES,
  GET_VEHICLES,
  GET_VENDOR,
  GET_WAYBILLS,
  GET_WHATS_THIS_MODAL_BY_ID,
  HTTP_FAILURE_ERRORS_READ,
  LOCK_OR_UNLOCK_PRE_ADVICE,
  MANUAL_PRE_ADVICE,
  MARK_NOT_ARRIVED_AT_DISTRIBUTING_TERMINAL,
  MARK_SHIPMENTS_DELAYED,
  MARK_SHIPMENTS_RESCHEDULED,
  MIGRATE_CUSTOMER,
  MODAL_CLOSE,
  MODAL_CLOSE_KEEP_PAGE_STATE,
  MODAL_OPEN,
  MOVE_ORDERS,
  MOVE_ORDERS_NEW,
  MOVE_TEMPLATE_SHIPMENTS_AND_STOPS,
  OPTIMIZE_SLOT_ON_SHIPMENT_LEVEL,
  PAGE_STATE_ADD,
  PRE_ADVICE_MANUAL_ATTEMPT,
  QUICK_EDIT_SHIPMENT,
  REJECT_ORDERS,
  REMOVE_AREA_FROM_SLOT,
  REMOVE_BOOKING_TIMES,
  REMOVE_ROLES_FROM_USER,
  REQUEST_PWD_RESET,
  REROLL_OUT_RECURRING_ROUTES,
  RESET_ORDER_PRICE_INFO,
  RESET_RECURRING_ORDER,
  RESOLVE_ADDRESS,
  RETURN_CONSIGNMENTS_MANUAL_OVERRIDE,
  REVERSED_OPTIMIZE_SLOT,
  ROLES,
  SAVE_CUSTOMER_EVENT_EMAIL,
  SAVE_ROUTE_POSTAL_CODE_RULES,
  SEARCH_CONSIGNMENTS,
  SEARCH_CUSTOMERS,
  SEARCH_DELETED_ORDERS,
  SEARCH_H2_ORDER,
  SEARCH_ORDERS,
  SEARCH_PRODUCTION_TIME_WINDOWS,
  SEND_MANUAL_DELAY_SMS,
  SEND_MANUAL_DELAY_SMS_NEW,
  SEND_PRE_PICKUP_SMS,
  SEND_PRE_PICKUP_SMS_NEW,
  SET_CONSIGNMENT_SLOT,
  SET_COURIER_LOCATION,
  SET_CUSTOMER_SERVICE_LEVEL,
  SET_DEPARTMENT_DEFAULT_TEMPLATES,
  SET_PRICE_EXPLANATION_LIST,
  TOGGLE_SHOW_CUSTOMER_PRICE,
  UNASSIGN_BULK_CONSIGNMENTS_FROM_SLOTS,
  UNASSIGN_CONSIGNMENT_FROM_SLOT,
  UNASSIGN_CONSIGNMENTS,
  UNASSIGN_COURIER_FROM_SLOT,
  UNASSIGN_UNIT_FROM_SLOT,
  UNASSIGN_VEHICLE_FROM_DEPARTMENT,
  UNASSIGN_VEHICLE_FROM_SLOT,
  UNRESOLVE_DELIVERY_ADDRESS,
  UNRESOLVE_PICKUP_ADDRESS,
  UPDATE_AREA_IN_SLOT,
  UPDATE_BANNER,
  UPDATE_BRANDED_TRACKING_ACCESS,
  UPDATE_CMS_NEWS,
  UPDATE_CONSIGNMENTS_PICKUP_LOCATION,
  UPDATE_COURIER_USER,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_BILLING_NUMBER,
  UPDATE_CUSTOMER_BOOKING_PAGE_ACCESS,
  UPDATE_CUSTOMER_GROUP,
  UPDATE_CUSTOMER_HD_INVOICING_FROM_DATE,
  UPDATE_CUSTOMER_INFORMATION,
  UPDATE_CUSTOMER_INVOICE_SPLIT,
  UPDATE_CUSTOMER_NPS_FROM_DATE,
  UPDATE_CUSTOMER_RETURN_ADDRESS,
  UPDATE_CUSTOMER_RETURN_LAST_LEG,
  UPDATE_CUSTOMER_SCAN_TO_CREATE_PACKAGES,
  UPDATE_CUSTOMER_SENDER_NAME,
  UPDATE_CUSTOMER_USE_TERMINAL_ADDRESS,
  UPDATE_DELIVERY_TIME,
  UPDATE_DELIVERY_TIMES,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_GROUP,
  UPDATE_MULTILEG_PRICE_CORRECTION,
  UPDATE_MULTISTOP_PRICE_CORRECTION,
  UPDATE_MY_PLANNER_DEPARTMENTS,
  UPDATE_ORDER_DEVIATION,
  UPDATE_ORDER_SERVICE_LEVEL,
  UPDATE_ORDER_VEHICLE_TYPE,
  UPDATE_PICKUP_AND_DELIVERY_TIMES,
  UPDATE_PLANNED_STOP_LOCATIONS,
  UPDATE_PLANNER,
  UPDATE_ROLE,
  UPDATE_ROUTE,
  UPDATE_ROUTE_SKIP_AUTO_DISPATCH,
  UPDATE_TEMPLATE_ROUTE_RULE,
  UPDATE_TEXT,
  UPDATE_UPSALES_RULE,
  UPDATE_VEHICLE_INFORMATION,
  UPDATE_WHATS_THIS_MODAL,
  UPLOAD_EXCEL_ADDRESSES,
  UPLOAD_EXCEL_ORDERS_V2,
  UPSERT_DEPARTMENT_TIME_WINDOW,
  UPSERT_TEMPLATE_ROUTE,
  VALIDATE_BANNER_URL
} from '../actionTypes'
import {
  AnyData,
  fetchEvenIfPresent,
  fetchIfNotInFlight,
  fetchIfNotPresent,
  fetchIfNotPresentWithAccess,
  ThunkDispatch,
  ThunkResult
} from './baseHelpers'
import { OptimizeSlotProps } from './helpersInstant'
import { addNotification } from './helpersNotifications'

export function departmentIdsToList(departmentIds: number | List<number> | number[]): List<number> {
  if (typeof departmentIds === 'number') {
    return List([departmentIds])
  } else if (List.isList(departmentIds)) {
    return departmentIds
  } else if (departmentIds.length) {
    return List(departmentIds)
  } else {
    return List()
  }
}

export const setPageStateValue = (key: string, value: any) => (dispatch: ThunkDispatch) =>
  dispatch({
    type: PAGE_STATE_ADD,
    key,
    value
  })

export const setAvailableDeliveryTimes = (key: string, value: any) => (dispatch: ThunkDispatch) =>
  dispatch({
    type: AVAILABLE_DELIVERY_TIMES_ADD,
    key,
    value
  })

export const queryLocal = (query: string, key?: string) => (dispatch: ThunkDispatch) =>
  dispatch({
    type: PAGE_STATE_ADD,
    key: key ? key : 'query',
    value: query
  })

export const getDepartments = () => fetchIfNotPresent(GET_DEPARTMENTS, { query: 'departments', params: {} })

export const getDepartmentsAlways = () => fetchIfNotInFlight(GET_DEPARTMENTS, { query: 'departments', params: {} })

export const getPlannedStopLocations = (departmentId: DepartmentIdType) =>
  fetchIfNotPresent(GET_PLANNED_STOP_LOCATIONS, { query: 'plannedStopLocations', params: { departmentId } })

export const getPlannedStopLocationsForDepartments = (departmentIds: List<DepartmentIdType>) =>
  fetchIfNotPresent(GET_PLANNED_STOP_LOCATIONS, {
    query: 'plannedStopLocationsForDepartments',
    params: { departmentIds }
  })

export const getPlannedStopsForSlot = (slotId: SlotIdType) =>
  fetchIfNotPresent(GET_PLANNED_STOPS_FOR_SLOT, { query: 'plannedStopsForSlot', params: { slotId } })

export const getDepartmentGroupRegionId = (departmentId: DepartmentIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_DEPARTMENT_GROUP_REGION_ID, {
      query: 'getDepartmentGroupRegionId',
      params: { departmentId }
    })
  )

export const getRouteLabels = (departmentIds: List<DepartmentIdType>) =>
  fetchIfNotPresent(GET_ROUTE_LABELS, { query: 'routeLabels', params: { departmentIds } })

export const getDepartmentTimeWindows = (departmentId: number) =>
  fetchFromCheckoutIfNotPresent(GET_DEPARTMENT_TIME_WINDOWS, {
    query: 'departmentTimeWindows',
    params: { departmentId }
  })

export const fetchFromCheckoutIfNotPresent: (
  actionType: ActionType,
  queryBody: QueryData
) => ThunkResult<Promise<ConsumedResponse>> =
  (actionType: ActionType, queryBody: QueryData) => (dispatch, getState) => {
    if (httpDone(getState, actionType, queryBody)) {
      return Promise.resolve(new Response(null, { status: 200 })) as Promise<ConsumedResponse>
    } else {
      return dispatch(checkoutApi.asyncQuery(actionType, queryBody))
    }
  }

export const getAllDepartmentsWithAdminLevelAccess = () =>
  fetchIfNotPresent(GET_ALL_DEPARTMENTS, { query: 'allDepartmentsWithAdminLevelAccess', params: {} })

export const getJobsStatus = () => fetchIfNotPresent(GET_JOBS_STATUS, { query: 'jobsStatus', params: {} })

export const createHoliday = (country: string, type: string, date: string) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(CREATE_HOLIDAY, {
      type: 'CREATE_HOLIDAY',
      payload: {
        country,
        type,
        date
      }
    })
  )
}

export const getHolidays = () => fetchIfNotPresent(GET_HOLIDAYS_DATA, { query: 'holiday', params: {} })

export const getArticles = (orderId: OrderIdType) =>
  fetchIfNotPresent(GET_ARTICLES, {
    query: 'articles',
    params: { orderId }
  })

export const deleteHoliday = (id: number) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncCommand(DELETE_HOLIDAY, { type: 'DELETE_HOLIDAY', payload: { id } }))
}

export const getNumberSeries = () => fetchIfNotPresent(GET_NUMBER_SERIES, { query: 'numberSeries', params: {} })

export const getOptimizeRequestUncached = (departmentId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_OPTIMIZE_REQUEST, {
      query: 'optimizeRequest',
      params: {
        department: departmentId
      }
    })
  )

export const getOptimizeRequest = (departmentId: number) =>
  fetchIfNotPresent(GET_OPTIMIZE_REQUEST, {
    query: 'optimizeRequest',
    params: {
      department: departmentId
    }
  })

export const getServiceMapping = () => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncQuery(GET_SERVICE_MAPPING_DATA, { query: 'serviceMappingData', params: {} }))
}

export const getServiceMappingById = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(api.asyncQuery(GET_SERVICE_MAPPING_DATA, { query: 'getServiceMappingDataById', params: { id } }))

export const addOrEditServiceMatrix = (payload: object) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_UPDATE_SERVICE_MAPPING, {
      type: ADD_UPDATE_SERVICE_MAPPING.name,
      payload
    })
  )

export const deleteServiceMatrix =
  (serviceCode: string, serviceName: string, alystraId: string | undefined) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DELETE_SERVICE_MAPPING, {
        type: DELETE_SERVICE_MAPPING.name,
        payload: { serviceCode, serviceName, alystraId }
      })
    )

export const getRoutePoints = (
  customerId?: number,
  departmentIds?: List<number>,
  fromDate?: string,
  toDate?: string,
  slotId?: number,
  alwaysFetch?: boolean,
  labelIds?: number[]
) => {
  const params: any = {
    fromDate: fromDate || DateTime.local().toISODate(),
    toDate: toDate || DateTime.local().plus({ days: 1 }).toISODate()
  }
  customerId && (params.customerId = customerId)
  departmentIds && (params.departmentIds = departmentIds)
  slotId && (params.slotId = slotId)
  if (labelIds && labelIds.length > 0) {
    params.labelIds = labelIds
  }
  if (alwaysFetch) {
    return fetchEvenIfPresent(GET_ROUTE_POINTS, { query: 'routePoints', params })
  }

  return fetchIfNotPresent(GET_ROUTE_POINTS, { query: 'routePoints', params })
}

export const getVehicles = (departmentIds: number | List<number> | number[]) => {
  const params: any = {
    departmentIds: departmentIdsToList(departmentIds)
  }

  return fetchIfNotPresent(GET_VEHICLES, {
    query: 'vehicles',
    params
  })
}

export const unassignVehicleFromDepartment =
  (departmentId: DepartmentIdType, vehicleId: VehicleIdType) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncDeleteCommand(UNASSIGN_VEHICLE_FROM_DEPARTMENT, {
        type: 'UNASSIGN_VEHICLE_FROM_DEPARTMENT',
        payload: { departmentId, vehicleId }
      })
    )
  }

export const createVehicle = (department: DepartmentIdType, payload: any) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncDeleteCommand(CREATE_VEHICLE, {
      type: 'CREATE_VEHICLE',
      payload: { department, ...payload }
    })
  )
}
export const updateVehicle =
  (department: DepartmentIdType, vehicle: VehicleIdType, payload: any) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncDeleteCommand(UPDATE_VEHICLE_INFORMATION, {
        type: 'UPDATE_VEHICLE_INFORMATION',
        payload: { department, vehicle, ...payload }
      })
    )
  }

export const getSlots = (
  departmentIds: number | List<number> | number[],
  fromDate: string,
  toDate: string,
  shallowFetch = false,
  excludeRoutePoints = false,
  includeProgress = false,
  slotIds?: List<SlotIdType>,
  labelIds?: number[]
) => {
  const params: any = {
    departmentIds: departmentIdsToList(departmentIds),
    fromDate: fromDate || DateTime.local().toISODate(),
    toDate: toDate || DateTime.local().plus({ days: 1 }).toISODate(),
    shallowFetch,
    excludeRoutePoints,
    includeProgress
  }

  if (slotIds) {
    params.slotIds = slotIds
  }

  if (labelIds && labelIds.length > 0) {
    params.labelIds = labelIds
  }

  return fetchIfNotPresent(GET_SLOTS, {
    query: 'slots',
    params
  })
}

export const getSlotsByUnitId = (unitId: UnitIdType, fromDate: DateTime) =>
  fetchIfNotPresent(GET_SLOTS_BY_UNIT_ID, {
    query: 'slots',
    params: {
      shallowFetch: true,
      excludeRoutePoints: true,
      fromDate: fromDate.toISODate(),
      toDate: fromDate.plus({ days: 1 }).toISODate(),
      unit: unitId
    }
  })

export const getRoutePostalCodeRules = (routeId: SlotIdType) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncQuery(GET_ROUTE_POSTAL_CODE_RULES, {
      query: 'routePostalCodeRules',
      params: { routeId }
    })
  )
}

const searchCustomersFactory =
  (query: string) => (departmentIds: List<DepartmentIdType>, searchPhrase: string) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncQuery(SEARCH_CUSTOMERS, {
        query,
        params: {
          departmentIds: departmentIdsToList(departmentIds),
          searchPhrase
        }
      })
    )
  }

export const searchCustomersWithoutSubcustomers = searchCustomersFactory('searchCustomersWithoutSubcustomers')
export const searchCustomers = searchCustomersFactory('searchCustomers')

export const subcustomersByAlystraId = (alystraId: string) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncQuery(GET_SUBCUSTOMERS, {
      query: 'subcustomersForAlystraId',
      params: {
        alystraId
      }
    })
  )
}

export const searchCustomerAllCountries =
  (searchPhrase: string, departmentIds?: DepartmentIdType[]) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncQuery(SEARCH_CUSTOMERS, {
        query: 'searchCustomerAllCountries',
        params: {
          searchPhrase,
          departmentIds
        }
      })
    )
  }

export const searchOrders =
  (params: ShipmentSearchParams, departmentIds: List<DepartmentIdType>) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncQuery(SEARCH_ORDERS, {
        query: 'searchOrders',
        params: {
          NEW_ORDER_SEARCH: isFeatureTogglesOn(['NEW_ORDER_SEARCH']),
          searchPhrase: params.searchPhrase || undefined,
          searchOperator: params.searchOperator || 'AND',
          states: params.states || undefined,
          customerIds: params.customers || undefined,
          fromDate: params.fromDate || undefined,
          toDate: params.toDate || undefined,
          withoutDeliveryDateOrders: params.dateOption === WITHOUT_DELIVERY_DATE || undefined,
          advancedSearch: params.advancedFilter
            ? { searchOperator: 'AND', advancedFilters: params.advancedFilter.advancedFilters }
            : undefined,
          departmentIds: departmentIdsToList(departmentIds)
        }
      })
    )
  }

export const searchDeletedOrders =
  (params: ShipmentSearchParams, departmentIds: List<DepartmentIdType>) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncQuery(SEARCH_DELETED_ORDERS, {
        query: 'searchDeletedOrders',
        params: {
          includeEvents: false,
          searchPhrase: params.searchPhrase ?? '',
          searchOperator: params.searchOperator || 'AND',
          fromDate: params.fromDate || undefined,
          toDate: params.toDate || undefined,
          departmentIds: departmentIdsToList(departmentIds)
        }
      })
    )

export const getUnconfirmedOrders =
  (params: DateParams, departmentIds: List<DepartmentIdType>) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncQuery(GET_UNCONFIRMED_ORDERS, {
        query: 'unconfirmedOrders',
        params: {
          fromDate: params.fromDate || undefined,
          toDate: params.toDate || undefined,
          departmentIds: departmentIdsToList(departmentIds)
        }
      })
    )
  }

export const acceptOrders = (selectedOrderIds: number[]) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ACCEPT_ORDERS, {
      type: 'ACCEPT_ORDERS',
      payload: {
        orderIds: selectedOrderIds
      }
    })
  )

export const rejectOrders =
  (selectedOrderIds: number[], reason: string, comment: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(REJECT_ORDERS, {
        type: 'REJECT_ORDERS',
        payload: {
          orderIds: selectedOrderIds,
          reason,
          otherReason: comment
        }
      })
    )

export const batchUpdateConsignments = (jsonBody: string) => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: BATCH_CONSIGNMENT_FETCH,
    isEntity: true,
    body: jsonBody
  })
}

export const searchConsignments =
  (
    customerId: number,
    searchPhrase: string,
    fromDate: string,
    toDate: string,
    includeEvents = true,
    departmentIds: List<DepartmentIdType>,
    customerAlystraId: string,
    state: string | undefined,
    searchDeletedOrders = false,
    withoutDateOrders = false,
    includeOrdersWithoutDate = false,
    includePreAdvice = false,
    onlyFailedPreAdvice = false,
    onlyReturnPreAdvice = false
  ) =>
  (dispatch: ThunkDispatch) => {
    const params: any = {}
    customerId && (params.customerId = customerId)
    params.includeEvents = includeEvents
    params.searchPhrase = searchPhrase ? searchPhrase : ''
    params.includeOrdersWithoutDate = includeOrdersWithoutDate
    params.onlyFailedPreAdvice = onlyFailedPreAdvice
    params.onlyReturnPreAdvice = onlyReturnPreAdvice
    params.includePreAdvice = includePreAdvice || onlyFailedPreAdvice || onlyReturnPreAdvice
    if (!withoutDateOrders) {
      params.fromDate = fromDate || DateTime.local().toISODate()
      params.toDate = toDate || DateTime.local().toISODate()
    }
    state && (params.state = state)
    withoutDateOrders && (params.withoutDateOrders = withoutDateOrders)
    departmentIds && isNotEmpty(departmentIds) && (params.departmentIds = departmentIdsToList(departmentIds))
    customerAlystraId && customerAlystraId !== 'null' ? (params.customerAlystraId = customerAlystraId) : ''

    params.searchOperator = 'OR'

    return searchDeletedOrders
      ? dispatch(api.asyncQuery(SEARCH_DELETED_ORDERS, { query: 'searchDeletedOrders', params }))
      : dispatch(api.asyncQuery(SEARCH_CONSIGNMENTS, { query: 'searchConsignments', params }))
  }

export const getConsignments = (
  departmentIds?: number | List<DepartmentIdType>,
  fromDate?: string,
  toDate?: string,
  includeEvents = true,
  state?: string,
  consignmentIds?: List<ConsignmentIdType>,
  slotIds?: List<SlotIdType>,
  allowedStates?: List<ConsignmentState>,
  alwaysFetch?: boolean
) => {
  const params: any = {}
  departmentIds && (params.departmentIds = departmentIdsToList(departmentIds))
  fromDate && (params.fromDate = fromDate)
  toDate && (params.toDate = toDate)
  params.includeEvents = includeEvents
  state && (params.state = state)
  consignmentIds && (params.consignmentIds = consignmentIds)
  slotIds && (params.slotIds = slotIds)
  allowedStates && (params.allowedStates = allowedStates)

  if (alwaysFetch) {
    return fetchEvenIfPresent(GET_CONSIGNMENTS, { query: 'consignments', params })
  }
  return fetchIfNotPresent(GET_CONSIGNMENTS, { query: 'consignments', params })
}

export const getUnassignedConsignmentEvents = (consignmentIds: List<ConsignmentIdType>) => {
  return fetchIfNotPresent(GET_UNASSIGNED_CONSIGNMENT_EVENTS, {
    query: 'unassignedConsignmentEvents',
    params: { ids: consignmentIds }
  })
}

export const getConsignmentsForSlots = (slotIds: List<SlotIdType>) => {
  return fetchIfNotPresent(GET_CONSIGNMENTS, {
    query: 'consignmentsForSlots',
    params: {
      slotIds
    }
  })
}

export const alwaysGetConsignmentsForSlots = (slotIds: List<SlotIdType>) => {
  return fetchEvenIfPresent(GET_CONSIGNMENTS, {
    query: 'consignmentsForSlots',
    params: {
      slotIds
    }
  })
}

export const getConsignmentsByIds = (ids: List<ConsignmentIdType>) => {
  return fetchIfNotPresent(GET_CONSIGNMENTS, {
    query: 'consignmentsByIds',
    params: {
      ids
    }
  })
}

export const getUnresolvedAddresses = (departmentIds: List<number>) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_UNRESOLVED_ADDRESSES, {
      query: 'unresolvedAddresses',
      params: { departmentIds }
    })
  )

export const getUnresolvedAddressCount = (departmentIds: Set<DepartmentIdType | null>) => (dispatch: ThunkDispatch) => {
  if (departmentIds.size > 0 && departmentIds.every((id) => Boolean(id))) {
    return dispatch(
      fetchIfNotInFlight(GET_UNRESOLVED_ADDRESS_COUNT, {
        query: 'unresolvedAddressCount',
        params: { departmentIds }
      })
    )
  }
}

export const getUnconfirmedOrdersCount = (departmentIds: Set<DepartmentIdType>) => (dispatch: ThunkDispatch) => {
  if (departmentIds.size > 0) {
    return dispatch(
      fetchIfNotInFlight(GET_UNCONFIRMED_ORDERS_COUNT, {
        query: 'unconfirmedOrdersCount',
        params: { departmentIds }
      })
    )
  }
}

export const getTemplatesByDepartmentIds = (departmentIds: List<DepartmentIdType>) =>
  fetchEvenIfPresent(GET_TEMPLATES, { query: 'templatesByDepartmentIds', params: { ids: departmentIds } })

export const saveTemplate =
  (
    template: { department: number; name: string; id: number | null; default?: boolean },
    templateSlots: List<{ slot: number }>
  ) =>
  (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(CREATE_OR_UPDATE_TEMPLATE, {
        type: 'CREATE_OR_UPDATE_TEMPLATE',
        payload: {
          template,
          templateSlots
        }
      })
    )
  }

export type SetDepartmentDefaultTemplates = { defaults: { department: number; template: number | null }[] }
export const setDepartmentDefaultTemplates = (payload: SetDepartmentDefaultTemplates) =>
  api.asyncCommand(SET_DEPARTMENT_DEFAULT_TEMPLATES, { type: SET_DEPARTMENT_DEFAULT_TEMPLATES.name, payload })

export const createSlotsFromTemplate =
  (templateId: number, departmentId: number, date: Date | string) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(CREATE_SLOTS_FROM_TEMPLATE, {
        type: 'CREATE_SLOTS_FROM_TEMPLATE',
        payload: {
          id: templateId,
          department: departmentId,
          date
        }
      })
    )
  }

export const deleteTemplate =
  (templateId: number) =>
  (dispatch: ThunkDispatch): Promise<ConsumedResponse> => {
    if (confirm(i18next.t('planner.templateDeleteConfirm'))) {
      return deleteTemplateRequest(templateId)(dispatch)
    } else {
      return new Promise((resolve, reject) => reject())
    }
  }

export const deleteTemplateRequest = (templateId: number) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(DELETE_TEMPLATE, {
      type: 'DELETE_TEMPLATE',
      payload: {
        id: templateId
      }
    })
  )
}

export const exportForInvoicing = (
  departmentId: number,
  fromDate: string,
  toDate: string,
  isRemoveControlColumnsChecked?: boolean
) =>
  api
    .fetchPost('/query', {
      query: 'export',
      params: {
        department: departmentId,
        fromDate: fromDate || DateTime.local().toISODate(),
        toDate: toDate || DateTime.local().toISODate(),
        isRemoveControlColumnsChecked
      }
    })
    .then((response) => response.blob())
    .then((blob) => saveAs(blob, 'export.csv'))

export const getSlotById = (slotId: number, shallowFetch = false) =>
  fetchIfNotPresent(GET_SLOT, { query: 'slotById', params: { id: slotId, shallowFetch } })

export const getSlotByIdAnyDepartment = (slotId: number) =>
  fetchIfNotPresent(GET_SLOT_ANY_DEPARTMENT, { query: 'slotByIdAnyDepartment', params: { slotId } })

export const getDriverForSlot = (slotId: number) =>
  fetchIfNotPresent(GET_DRIVER_FOR_SLOT, { query: 'driverForSlot', params: { slotId } })

export const getUnits = (departmentIds: Set<DepartmentIdType>) => {
  const params = {
    departmentIds: departmentIds.toArray()
  }
  return fetchIfNotPresent(GET_UNITS, { query: 'units', params })
}

export const cancelOptimizingRequest = (id: number) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncCommand(CANCEL_RUNNING_OPTIMIZING, {
      type: 'CANCEL_RUNNING_OPTIMIZING',
      payload: { id }
    })
  )
}

export const getOptimizingData = (date: string) =>
  fetchIfNotInFlight(GET_OPTIMIZING_DATA, {
    query: 'optimizingData',
    params: {
      from: date
    }
  })

export const getApolloAuditLog = (date: string) =>
  fetchIfNotInFlight(GET_APOLLO_AUDIT_LOG, {
    query: 'apolloAuditLogEntries',
    params: {
      date
    }
  })

export const getApolloAuditLogDetails = (id: number) =>
  fetchIfNotPresent(GET_APOLLO_AUDIT_LOG_DETAILS, {
    query: 'apolloAuditLogDetails',
    params: {
      id
    }
  })

export const getOptimizingRequestData = (requestId: number) =>
  fetchIfNotPresent(GET_OPTIMIZING_REQUEST_DATA, {
    query: 'optimizingRequestData',
    params: {
      id: requestId
    }
  })

export const getOptimizingResponseData = (requestId: number) =>
  fetchIfNotPresent(GET_OPTIMIZING_RESPONSE_DATA, {
    query: 'optimizingResponseData',
    params: {
      id: requestId
    }
  })

export const getOptimizingErrorData = (requestId: number) =>
  fetchIfNotPresent(GET_OPTIMIZING_ERROR_DATA, {
    query: 'optimizingErrorData',
    params: {
      id: requestId
    }
  })

export const getCourierLocationsByDepartmentId = (departmentIds: number | number[] | List<number>) =>
  fetchIfNotPresent(GET_COURIER_LOCATIONS, {
    query: 'courierLocationsByDepartmentId',
    params: { id: departmentIdsToList(departmentIds) }
  })

export const getCourierLocationsBySlotId = (slotId: SlotIdType) =>
  fetchEvenIfPresent(GET_COURIER_LOCATIONS, { query: 'courierLocationsBySlotId', params: { slotId } })

export const getTexts = (groupKey = 'SERVICE_MATRIX') =>
  fetchIfNotPresent(GET_TEXTS, {
    query: 'texts',
    params: {
      group: groupKey
    }
  })

export const getTextById = (id: number) =>
  fetchIfNotPresent(GET_TEXT_BY_ID, {
    query: 'getTextById',
    params: {
      id
    }
  })

export const createText = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_TEXT, {
      type: ADD_TEXT.name,
      payload
    })
  )

export const updateTextRequest = (payload: AnyData) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_TEXT, {
      type: 'UPDATE_TEXT',
      payload
    })
  )
}

export const deleteTextById = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_TEXT, {
      type: DELETE_TEXT.name,
      payload: { id }
    })
  )

export const createUpsalesRule = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_UPSALES_RULE, {
      type: ADD_UPSALES_RULE.name,
      payload
    })
  )

export const updateUpsalesRule = (payload: AnyData) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_UPSALES_RULE, {
      type: UPDATE_UPSALES_RULE.name,
      payload
    })
  )
}

export const deleteUpsalesRule = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_UPSALES_RULE, {
      type: DELETE_UPSALES_RULE.name,
      payload: { id }
    })
  )

export const enableOrDisableUpsalesRule = (id: number, enable: boolean) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(enable ? ENABLE_UPSALES_RULE : DISABLE_UPSALES_RULE, {
      type: (enable ? ENABLE_UPSALES_RULE : DISABLE_UPSALES_RULE).name,
      payload: { id }
    })
  )

export const getUpsalesRuleById = (id: number) =>
  api.asyncQuery(GET_UPSALES_RULE_BY_ID, {
    query: 'upsalesRuleById',
    params: {
      id
    }
  })

export const getUpsalesRules = () =>
  fetchIfNotPresent(GET_UPSALES_RULES, {
    query: 'upsalesRules',
    params: {}
  })

export const getTemplateRouteRules = (departmentId: number) =>
  api.asyncQuery(GET_TEMPLATE_ROUTE_RULES, {
    query: 'templateRouteRules',
    params: { departmentId }
  })

export const getTemplateRouteRuleById = (id: number) =>
  api.asyncQuery(GET_TEMPLATE_ROUTE_RULE_BY_ID, {
    query: 'templateRouteRuleById',
    params: { id }
  })

export const createTemplateRouteRule = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_TEMPLATE_ROUTE_RULE, {
      type: ADD_TEMPLATE_ROUTE_RULE.name,
      payload
    })
  )

export const updateTemplateRouteRule = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_TEMPLATE_ROUTE_RULE, {
      type: UPDATE_TEMPLATE_ROUTE_RULE.name,
      payload
    })
  )

export const deleteTemplateRouteRule = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_TEMPLATE_ROUTE_RULE, {
      type: DELETE_TEMPLATE_ROUTE_RULE.name,
      payload: { id }
    })
  )

export const openModal = (modalClass: any, props: AnyData, modalName?: string) => (dispatch: ThunkDispatch) => {
  dispatch({
    type: MODAL_OPEN,
    className: modalClass,
    props,
    modalName
  })
}

export const closeModal =
  (keepState = false) =>
  (dispatch: ThunkDispatch) => {
    dispatch({
      type: keepState ? MODAL_CLOSE_KEEP_PAGE_STATE : MODAL_CLOSE
    })
  }

export const openDrawer = (drawerClass: string | React.ElementType, props: AnyData) => (dispatch: ThunkDispatch) => {
  dispatch({
    type: DRAWER_OPEN,
    className: drawerClass,
    props
  })
}

export const closeDrawer = () => (dispatch: ThunkDispatch) => {
  dispatch({
    type: DRAWER_CLOSE
  })
}

export type UnitPayload = {
  weightCapacity: string | null
  color: null | string
  co2: string
  isActive: boolean
  vehicleControlComment: string
  capacity: string
  vehicleBrand: string
  shouldDriverReturn: boolean
  vehicleModel: string
  commercialTrafficEligibility: boolean
  department: number
  serviceTimeFactor: number
  vehicleType: string
  vehicleControl: string
  volumeCapacity: string | null
  break:
    | null
    | { duration: string; type: any; earliest: any; latest: any }
    | {
        duration: string
        maxWorkingTime: string
        type: any
      }
  isUnit: boolean
  speedFactor: number
  alystraId: string | null
  fuelType: string
  courier: number | null
  courierUserIds: number[]
  registrationNumber: string
  euroClass: string
  name: string
  maxRangeKm: string | null
  location: { start: { lng: number; lat: number }; end: { lng: number; lat: number } }
}

export const getUnitPayload = (values: ImmutableMap<UnitFormProps>, departmentId: number): UnitPayload => {
  return {
    name: values.get('name'),
    courier: values.get('courierId') || null,
    capacity: values.get('capacity'),
    weightCapacity: values.get('weightCapacity') || null,
    volumeCapacity: values.get('volumeCapacity') || null,
    speedFactor: values.get('speedFactor')[0],
    serviceTimeFactor: values.get('serviceTimeFactor')[0],
    department: departmentId,
    alystraId: values.get('alystraId'),
    location: {
      start: {
        lng: values.getIn(['startLocation', 'lng']),
        lat: values.getIn(['startLocation', 'lat'])
      },
      end: {
        lng: values.getIn(['endLocation', 'lng']),
        lat: values.getIn(['endLocation', 'lat'])
      }
    },
    shouldDriverReturn: !values.get('shouldDriverNotReturn'),
    isActive: values.get('isActive'),
    vehicleType: values.get('vehicleType'),
    fuelType: values.get('fuelType'),
    color: values.get('color') == '#ffffff' ? null : values.get('color'),
    maxRangeKm: values.get('maxRangeKm') || null,
    courierUserIds:
      values
        .get('courierUsers')
        ?.toList()
        ?.map((v) => v.get('id'))
        ?.toJS() || [],
    isUnit: values.get('isUnit') || false,
    registrationNumber: values.get('registrationNumber') || '',
    commercialTrafficEligibility: values.get('commercialTrafficEligibility') || false,
    vehicleBrand: values.get('vehicleBrand') || '',
    vehicleModel: values.get('vehicleModel') || '',
    vehicleControl: values.get('vehicleControl') || '',
    vehicleControlComment: values.get('vehicleControlComment') || '',
    euroClass: values.get('euroClass') || '',
    co2: values.get('co2') || '',
    break: toBreak(values)
  }
}

export enum BreakType {
  NoBreakTime = 'NoBreakTime',
  TimeWindow = 'TimeWindow',
  WorkingTime = 'WorkingTime'
}

export const toBreak = (values: Map<string, any>) => {
  if (values.get('breakType') === BreakType.NoBreakTime) {
    return null
  } else if (values.get('breakType') === BreakType.TimeWindow) {
    return {
      type: values.get('breakType'),
      duration: Duration.fromDurationLike({ minute: values.get('breakTimeWindowDuration') }).toISO(),
      earliest: values.get('breakEarliest'),
      latest: values.get('breakLatest')
    }
  } else {
    return {
      type: values.get('breakType'),
      duration: Duration.fromDurationLike({ minute: values.get('breakWorkingTimeDuration') }).toISO(),
      maxWorkingTime: Duration.fromDurationLike({ hour: values.get('breakMaxWorkingTime') }).toISO()
    }
  }
}

export const closeModalAndNotify = (title: string, message = '', timeout = 1000, keepState = false) => {
  return (dispatch: ThunkDispatch) => {
    dispatch(closeModal(keepState))
    dispatch(addNotification({ title, message, timeout }))
  }
}

export const getOrderByShipmentId = (shipmentId: string) =>
  fetchIfNotPresent(GET_ORDER_BY_SHIPMENT_ID, { query: 'orders', params: { shipmentId } })

export const getOrdersByRecurringOrderId = (recurringOrderId: number) =>
  api.asyncQuery(GET_ORDERS_BY_RECURRING_ORDER_ID, { query: 'orders', params: { recurringOrderId } })

export const createOrUpdateOrder =
  (payload: AnyData, onSuccessRedirectUrl: string | null, push: (url: string) => void) => (dispatch: ThunkDispatch) => {
    const res = dispatch(asyncOptimusCreateOrders(CREATE_ORDER_OPTIMUS, payload))
    return res
      ? res.then(() => {
          if (onSuccessRedirectUrl) {
            push(onSuccessRedirectUrl)
          }
          dispatch(closeModalAndNotify(i18next.t('instant.booking.created')))
        })
      : res
  }

export const createUnit = (values: ImmutableMap<UnitFormProps>, departmentId: number) => {
  return (dispatch: ThunkDispatch) => {
    dispatch(createUnit2(getUnitPayload(values, departmentId))).then(
      (res) => (res.ok ? dispatch(closeModalAndNotify(i18next.t('courier.created'))) : res),
      (err) => console.log('createUnit', err)
    )
  }
}

export const createUnit2 = (payload: UnitPayload) =>
  api.asyncCommand(CREATE_UNIT, {
    type: 'CREATE_UNIT',
    payload
  })

export const createPlannerJS = (values: PlannerProps) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_PLANNER, {
        type: 'CREATE_PLANNER',
        payload: { ...values, email: values.email !== '' ? values.email : undefined }
      })
    )
}

export const createCourierUserJS = (values: CreateUpdateCourierFormProps, departmentId: number | undefined) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_COURIER_USER, {
        type: 'CREATE_COURIER_USER',
        payload: {
          name: values.name,
          phoneNumber: values.phoneNumber,
          canLogIn: values.canLogIn,
          secureLoginEnabled: values.secureLoginEnabled,
          driverId: values.driverId,
          unitIds: [],
          alcoholDeliveryEducationDate: values.alcoholDeliveryEducation ? values.alcoholDeliveryEducationDate : null,
          alcoholDeliveryEducationValidTo: values.alcoholDeliveryEducation
            ? values.alcoholDeliveryEducationValidTo
            : null,
          departmentId,
          email: values.email,
          dateOfBirth: values.dateOfBirth,
          occupationalInjuryInsurance: values.occupationalInjuryInsurance,
          courierScanEnabled: values.courierScanEnabled
        }
      })
    )
}

export const updateCourierUserJS = (values: CreateUpdateCourierFormProps, departmentId: number | undefined) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_COURIER_USER, {
        type: 'UPDATE_COURIER_USER',
        payload: {
          id: values.id,
          name: values.name,
          phoneNumber: values.phoneNumber,
          canLogIn: values.canLogIn,
          secureLoginEnabled: values.secureLoginEnabled,
          driverId: values.driverId,
          unitIds: [],
          alcoholDeliveryEducationDate: values.alcoholDeliveryEducation ? values.alcoholDeliveryEducationDate : null,
          alcoholDeliveryEducationValidTo: values.alcoholDeliveryEducation
            ? values.alcoholDeliveryEducationValidTo
            : null,
          departmentId,
          email: values.email,
          dateOfBirth: values.dateOfBirth,
          occupationalInjuryInsurance: values.occupationalInjuryInsurance,
          courierScanEnabled: values.courierScanEnabled
        }
      })
    )
}

export const createDepartmentRequest = (values: DepartmentFormValues) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_DEPARTMENT, {
        type: 'CREATE_DEPARTMENT',
        payload: { department: formatDepartmentPayload(values) }
      })
    )
}

export const updateDepartmentRequest = (values: DepartmentFormValues) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_DEPARTMENT, {
        type: 'UPDATE_DEPARTMENT',
        payload: { department: formatDepartmentPayload(values) }
      })
    )
}

export const updatePlannedStopLocations = (
  departmentId: DepartmentIdType,
  plannedStopLocations: PlannedStopLocationProps[] | null
) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_PLANNED_STOP_LOCATIONS, {
        type: 'UPDATE_PLANNED_STOP_LOCATIONS',
        payload: { departmentId, plannedStopLocations }
      })
    )
}

export const addLabel = (departmentId: DepartmentIdType, categoryName: string, labelName: string) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_ROUTE_LABEL, {
        type: 'CREATE_ROUTE_LABEL',
        payload: { departmentId, categoryName, labelName }
      })
    )
}

export const removeLabel = (departmentId: DepartmentIdType, id: number) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DELETE_ROUTE_LABEL, {
        type: 'DELETE_ROUTE_LABEL',
        payload: { departmentId, id }
      })
    )
}

const formatDepartmentPayload = (values: DepartmentFormValues) => {
  // Convert form fields that need more than primitives.
  const { hasRegionOptions: _, ...rest } = values
  const payload: { [key: string]: unknown } = {
    emailAddresses: rest.emailAddress ? [rest.emailAddress] : null,
    location: { lat: rest.lat, lng: rest.lng },
    npsId: Number.parseInt(rest.npsId, 10)
  }

  // Convert empty strings from blank form fields into null values for the backend.
  for (const [k, v] of nullEmptyStrings(Object.entries(rest))) {
    payload[k] = v
  }

  return payload
}

const nullEmptyStrings = (input: [any, any][]): (readonly [any, unknown])[] =>
  input.map(([k, v]) => {
    const newV = nullEmptyString(v)
    return [k, newV]
  })

const nullEmptyString = (v: unknown): unknown => {
  if (v === null) {
    return null
  } else if (v === '') {
    return null
  } else if (Array.isArray(v)) {
    return v.map((value) => nullEmptyString(value))
  } else if (typeof v === 'object') {
    return Object.fromEntries(nullEmptyStrings(Object.entries(v)))
  } else return v
}

interface DepartmentTimeWindowProps {
  id?: number
  departmentId?: number
  day: string
  cutoff: string
  pickupEarliest: string
  pickupLatest: string
  deliveryEarliest: string
  deliveryLatest: string
  type: string
}

export function upsertWindows(departmentId: DepartmentIdType | undefined, windows: DepartmentTimeWindowProps[]) {
  return (dispatch: ThunkDispatch) => {
    // Dispatch one upsert command for each time window.
    const payload = windows.map((window) => ({
      ...window,
      departmentId: window.departmentId || departmentId,
      day: window.day.includes('sameday') ? window.day.split('_').pop() : window.day,
      type: window.day.includes('sameday') ? 'H2_SameDay' : 'H2'
    }))

    return dispatch(
      checkoutApi.asyncCommand(UPSERT_DEPARTMENT_TIME_WINDOW, {
        type: 'UPSERT_DEPARTMENT_TIME_WINDOW',
        payload
      })
    )
  }
}

export const updatePlannerJS = (values: PlannerProps) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_PLANNER, {
        type: 'UPDATE_PLANNER',
        payload: { ...values, email: values.email !== '' ? values.email : undefined }
      })
    )
}

export const updateMyPlannerDepartments = (departments: number[]) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_MY_PLANNER_DEPARTMENTS, {
      type: 'UPDATE_MY_PLANNER_DEPARTMENTS',
      payload: { departments }
    })
  )
export const removeRolesFromPlanner = (roleIds: number[], userId: number) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(REMOVE_ROLES_FROM_USER, {
        type: 'REMOVE_ROLES_FROM_USER',
        payload: { roleIds, userId }
      })
    )
}
export const addRolesToPlanner = (roleIds: number[], userId: number) => {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(ADD_ROLES_TO_USER, {
        type: 'ADD_ROLES_TO_USER',
        payload: { roleIds, userId }
      })
    )
}

export const updateAreaInSlot = (slotId: number, area: any) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_AREA_IN_SLOT, { type: 'UPDATE_AREA_IN_SLOT', payload: { slot: slotId, area } })
  )
}

export const removeAreaFromSlot = (slotId: number) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncCommand(REMOVE_AREA_FROM_SLOT, { type: 'REMOVE_AREA_FROM_SLOT', payload: { slot: slotId } }))
}

export const createRoute = (departmentId: number, slotData: Slot) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(CREATE_ROUTE, { type: 'CREATE_ROUTE', payload: { department: departmentId, slot: slotData } })
  )
}

export const updateRouteCommand = (departmentId: number, slotData: Slot) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_ROUTE, { type: 'UPDATE_ROUTE', payload: { department: departmentId, slot: slotData } })
  )
}

export const updateRoute = (departmentId: number, slotData: Slot, keepState?: boolean) => (dispatch: ThunkDispatch) => {
  return updateRouteCommand(
    departmentId,
    slotData
  )(dispatch).then((res) =>
    res.ok ? dispatch(closeModalAndNotify(i18next.t('planner.routeUpdated'), undefined, undefined, keepState)) : res
  )
}

export const saveRoutePostalCodeRules =
  (routeId: number, rules: RoutePostalCodeRuleProps[], applyToConnectedRule: boolean, excludedServiceCodes: string[]) =>
  (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(SAVE_ROUTE_POSTAL_CODE_RULES, {
        type: SAVE_ROUTE_POSTAL_CODE_RULES.name,
        payload: { routeId, rules, applyToConnectedRule, excludedServiceCodes }
      })
    )
  }

export const connectRouteToTemplateRouteRule =
  (routeId: number, templateRouteRuleId: number) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(CONNECT_ROUTE_TO_TEMPLATE_ROUTE_RULE, {
        type: CONNECT_ROUTE_TO_TEMPLATE_ROUTE_RULE.name,
        payload: { routeId, templateRouteRuleId }
      })
    )
  }

export const updateRouteSkipAutoDispatch =
  (routeId: number, skipAutoDispatch: boolean) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(UPDATE_ROUTE_SKIP_AUTO_DISPATCH, {
        type: UPDATE_ROUTE_SKIP_AUTO_DISPATCH.name,
        payload: { routeId, skipAutoDispatch }
      })
    )
  }

export const deleteSlot =
  (slotId: number, onSuccessRedirectUrl?: string, push?: (url: string) => void) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncDeleteCommand(
        DELETE_SLOT,
        { type: 'DELETE_SLOT', payload: { slot: slotId } },
        onSuccessRedirectUrl,
        push
      )
    )
  }

export const deleteUser =
  (userId: number, onSuccessRedirectUrl?: string, push?: (url: string) => void) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncDeleteCommand(DELETE_USER, { type: 'DELETE_USER', payload: { userId } }, onSuccessRedirectUrl, push)
    )
  }

export const completeSlotPlanning = (slotId: number) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(COMPLETE_SLOT_PLANNING, { type: COMPLETE_SLOT_PLANNING.name, payload: { slot: slotId } })
  )
}

export const deleteOrders =
  (orderIds: Set<number>, onSuccessRedirectUrl?: string, push?: (url: string) => void) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncDeleteCommand(
        DELETE_ORDERS,
        { type: 'DELETE_ORDERS', payload: { orderIds } },
        onSuccessRedirectUrl,
        push
      )
    )
  }

export const copyDeviatedOrder =
  (orderId: number, notifyOnResponse = true) =>
  (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(COPY_DEVIATED_ORDER, {
        type: 'COPY_DEVIATED_ORDER',
        payload: { orderId }
      })
    ).then(
      (res) => {
        if (!notifyOnResponse || !res.ok) {
          return res
        }

        dispatch(closeModalAndNotify(i18next.t('consignment.orderDuplicated')))
      },
      (err) => {
        console.log('COPY_DEVIATED_ORDER', err)

        if (notifyOnResponse) {
          dispatch(
            addNotification({ title: i18next.t('consignment.orderDuplicatedFailed'), message: '', timeout: 10000 })
          )
        }
      }
    )
  }

export const returnToSender =
  (orderId: number, notifyOnResponse = true) =>
  (dispatch: ThunkDispatch) => {
    return dispatch(createMultilegReturn(orderId)).then(
      (res) => {
        if (!res.ok) return false
        if (notifyOnResponse) {
          dispatch(closeModalAndNotify(i18next.t('manageReturns.returnToSenderQueued')))
        }
        return true
      },
      (err) => {
        console.log('CREATE_MULTILEG_RETURN', err)

        if (notifyOnResponse) {
          dispatch(
            addNotification({ title: i18next.t('manageReturns.returnToSenderFailed'), message: '', timeout: 10000 })
          )
        }

        return false
      }
    )
  }

export const reversedOptimizeSlot = (slot: number) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncCommand(REVERSED_OPTIMIZE_SLOT, { type: 'REVERSED_OPTIMIZE_SLOT', payload: { slot } }))
}

export const createNumberSeries = (type: string, current: number, max: number) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(CREATE_NUMBER_SERIES, {
      type: 'CREATE_NUMBER_SERIES',
      payload: { type, currentNumber: current, maxNumber: max }
    })
  )
}

export const deleteNumberSeries = (id: number) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncCommand(DELETE_NUMBER_SERIES, { type: 'DELETE_NUMBER_SERIES', payload: { id } }))
}

export const uploadExcelOrdersV2 = (files: UploadFile[], departmentId: number) => (dispatch: ThunkDispatch) => {
  const formData = new FormData()
  formData.append('departmentId', toString(departmentId))
  formData.append('file', files[0])

  return dispatch(api.asyncPostFormData(UPLOAD_EXCEL_ORDERS_V2, '/uploadExcelOrdersV2', formData))
}

export const uploadExcelAddresses = (file: File, customerId?: number) => (dispatch: ThunkDispatch) => {
  const formData = new FormData()
  formData.append('file', file)
  customerId && formData.append('customerId', toString(customerId))

  return dispatch(api.asyncPostFormData(UPLOAD_EXCEL_ADDRESSES, '/uploadExcelAddresses', formData))
}

export const downloadExcelAddressesForCustomer = (
  customerNumber: string,
  subcustomer: string | null,
  language: string
) =>
  api
    .fetchPost('/downloadCustomerAddresses', {
      params: {
        customerNumber,
        subcustomer,
        language
      }
    })
    .then((response) => response.blob())
    .then((blob) => saveAs(blob, `addresses_${customerNumberAndSubcustomer(customerNumber, subcustomer)}.xlsx`))
    .catch((err) => console.error(err))

export const updateConsignmentsPickupLocation = (payload: AnyData) => {
  return (dispatch: ThunkDispatch) => {
    updateConsignmentsPickupLocationNew(payload)(dispatch).then(
      (res) => (res.ok ? dispatch(closeModalAndNotify(i18next.t('consignment.updated'))) : res),
      (err) => console.log('updateConsignmentsPickupLocation', err)
    )
  }
}

export const updateConsignmentsPickupLocationNew = (payload: AnyData) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CONSIGNMENTS_PICKUP_LOCATION, {
      type: UPDATE_CONSIGNMENTS_PICKUP_LOCATION.name,
      payload
    })
  )
}

export const setCourierLocation =
  (unitId: number, lat: number, lng: number, accuracy: string, timestampIso: string) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(SET_COURIER_LOCATION, {
        type: 'SET_COURIER_LOCATION',
        payload: {
          unit: unitId,
          location: {
            lat,
            lng,
            accuracy,
            time: timestampIso
          }
        }
      })
    )
  }

export const resolveAddress =
  (
    unresolvedId: UnresolvedAddressIdType,
    lat: string | number,
    lng: string | number,
    departmentIds: List<DepartmentIdType>
  ) =>
  (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(RESOLVE_ADDRESS, {
        type: 'RESOLVE_ADDRESS',
        payload: { unresolvedAddressId: unresolvedId, location: { lat, lng } }
      })
    ).then(
      (res) => {
        if (res.ok) {
          dispatch(getUnresolvedAddressCount(departmentIds.toSet()))?.then()
          dispatch(getUnresolvedAddresses(departmentIds))?.then()
        } else return res
      },
      (err) => console.log('resolveAddress', err)
    )
  }

export const isReadOnlyUser = (user: SessionUser) => user.get('role') === ROLE_READ_ONLY_PLANNER

export const resetAllHttpStatus = () => (dispatch: ThunkDispatch) => {
  dispatch({ type: CLEAR_ALL_HTTP_STATUS })
  dispatch({ type: CLEAR_OPTIMIZING_DATA })
  dispatch({ type: CLEAR_APOLLO_AUDIT_LOG })
}

export const resetHttpStatuses = (httpStatuses: string[]) => (dispatch: ThunkDispatch) => {
  dispatch({ type: CLEAR_HTTP_STATUS, httpStatuses })
}

export const markHttpFailuresAsRead = () => (dispatch: ThunkDispatch) => {
  dispatch({ type: HTTP_FAILURE_ERRORS_READ })
}

export const unassignBulkConsignmentsFromSlotsDispatch =
  (consignmentIds: Set<ConsignmentIdType>) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UNASSIGN_BULK_CONSIGNMENTS_FROM_SLOTS, {
        type: UNASSIGN_BULK_CONSIGNMENTS_FROM_SLOTS.name,
        payload: {
          consignments: consignmentIds
        }
      })
    )

export const unassignBulkConsignmentsFromSlots =
  (consignmentIds: Set<ConsignmentIdType>) => (dispatch: ThunkDispatch) =>
    unassignBulkConsignmentsFromSlotsDispatch(consignmentIds)(dispatch).then(
      (res) =>
        res.ok
          ? dispatch(
              addNotification({
                title: i18next.t('planner.unassignBulkConsignmentsFromSlots'),
                message: '',
                timeout: 10000
              })
            )
          : res,
      (err) => console.log('unassignBulkConsignmentsFromSlots', err)
    )

export const plainUnassignConsignmentsFromSlot =
  (slotId: number, consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(UNASSIGN_CONSIGNMENT_FROM_SLOT, {
        type: 'UNASSIGN_CONSIGNMENT_FROM_SLOT',
        payload: {
          consignments: consignmentIds,
          slot: slotId
        }
      })
    )
  }
export const unassignConsignmentsFromSlot =
  (slotId: number, consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
    if (confirm(i18next.t('planner.unassignConsignmentFromSlot'))) {
      return dispatch(
        api.asyncCommand(UNASSIGN_CONSIGNMENT_FROM_SLOT, {
          type: 'UNASSIGN_CONSIGNMENT_FROM_SLOT',
          payload: {
            consignments: consignmentIds,
            slot: slotId
          }
        })
      ).then(
        (res) =>
          res.ok
            ? dispatch(
                addNotification({
                  title: i18next.t('planner.unassignedFromSlot'),
                  message: '',
                  timeout: 10000
                })
              )
            : res,
        (err) => console.log('unassignConsignmentFromSlot', err)
      )
    }
  }

export const unassignConsignmentsFromSlotJS =
  (slotId: number, consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(UNASSIGN_CONSIGNMENT_FROM_SLOT, {
        type: 'UNASSIGN_CONSIGNMENT_FROM_SLOT',
        payload: {
          consignments: consignmentIds,
          slot: slotId
        }
      })
    )
  }

export const deleteBreakFromRoute =
  (id: number, slot: number | undefined, arrival: string, callback?: () => void) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(DELETE_BREAK_FROM_ROUTE, {
        type: 'DELETE_BREAK_FROM_ROUTE',
        payload: {
          id,
          slot,
          arrival
        }
      })
    ).then(
      (res) =>
        res.ok && callback
          ? callback()
          : res.ok
            ? dispatch(
                addNotification({ title: i18next.t('planner.breakDeletedFromRoute'), message: '', timeout: 10000 })
              )
            : res,
      (err) => console.log('breakDeletedFromRoute', err)
    )
  }

export const unassignConsignmentsDispatch = (consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UNASSIGN_CONSIGNMENTS, {
      type: 'UNASSIGN_CONSIGNMENTS',
      payload: {
        consignments: consignmentIds
      }
    })
  )
}

export const unassignConsignments = (consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
  return unassignConsignmentsDispatch(consignmentIds)(dispatch).then(
    (res) =>
      res.ok
        ? dispatch(
            addNotification({
              title: i18next.t('planner.unassignBulkConsignmentsFromSlots'),
              message: '',
              timeout: 10000
            })
          )
        : res,
    (err) => {
      console.log('unassignConsignments', err)
      dispatch(addNotification({ title: 'Unable to unassign', message: '', timeout: 10000 }))
    }
  )
}

export const forceUnassignConsignmentsDispatch = (consignmentIds: Set<number>) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(FORCE_UNASSIGN_CONSIGNMENTS, {
      type: 'FORCE_UNASSIGN_CONSIGNMENTS',
      payload: {
        consignments: consignmentIds
      }
    })
  )

export const forceUnassignConsignments = (consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
  return forceUnassignConsignmentsDispatch(consignmentIds)(dispatch).then(
    (res) =>
      res.ok
        ? dispatch(
            addNotification({
              title: i18next.t('planner.unassignedFromSlot'),
              message: '',
              timeout: 5000
            })
          )
        : res,
    (err) => {
      console.log('unassignConsignments', err)
      dispatch(addNotification({ title: 'Unable to unassign', message: '', timeout: 10000 }))
    }
  )
}

export const updatePickupAndDeliveryTimes = (payload: AnyData) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_PICKUP_AND_DELIVERY_TIMES, {
      type: 'UPDATE_PICKUP_AND_DELIVERY_TIMES',
      payload
    })
  ).then(
    (res) => (res.ok ? dispatch(closeModalAndNotify(i18next.t('consignment.updated'))) : res),
    (err) => {
      console.log('update delivery times', err)
      dispatch(addNotification({ title: 'Unable to update', message: '', timeout: 10000 }))
    }
  )
}

export const plainChangeSlotForConsignments =
  (slot: string, fromSlotId: number, consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(SET_CONSIGNMENT_SLOT, {
        type: 'UPDATE_CONSIGNMENT_SLOT',
        payload: {
          consignments: consignmentIds,
          slot,
          oldSlotId: fromSlotId
        }
      })
    )
  }

export const addOrderToSlotAndReoptimize =
  (slotId: number, orderId: number, consignmentIds: Set<number>) => (dispatch: ThunkDispatch) => {
    const payload: OptimizeSlotProps = {
      slot: slotId,
      orders: Set([orderId]),
      consignments: Set(consignmentIds),
      flexPickups: Set([]),
      flexDeliveries: Set([]),
      forcedOrderPickups: Set([]),
      forcedOrderDeliveries: Set([]),
      flexPlannedStops: [],
      forcedPlannedStops: [],
      usePrevious: true,
      returnRoutePointSuggestions: false,
      optimizeOnRoutePointSuggestionsOnly: true,
      ignoreCourierBreak: false,
      applySuggestedRoute: true,
      optimizingType: getSelectedOptimizingType()
    }
    return dispatch(
      api.asyncCommand(OPTIMIZE_SLOT_ON_SHIPMENT_LEVEL, {
        type: 'OPTIMIZE_SLOT_ON_SHIPMENT_LEVEL',
        payload
      })
    ).then(
      (res) => (res.ok ? dispatch(closeModalAndNotify(i18next.t('consignment.optimizingNewSlot'))) : res),
      (err) => console.log('optimizeSlotOnShipmentLevel', err)
    )
  }

export const manuallyDeliverConsignments =
  (consignmentIds: Set<number>, timestamp: string, selectedUnitId: string, selectedUserId: string, name: string) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DELIVER_CONSIGNMENT_MANUAL_OVERRIDE, {
        type: 'DELIVER_CONSIGNMENT_MANUAL_OVERRIDE',
        payload: {
          consignments: consignmentIds,
          timestamp,
          recipientNameText: name,
          unitId: selectedUnitId,
          userId: selectedUserId
        }
      })
    )

export const manuallyReturnConsignments =
  (
    consignmentIds: Set<number>,
    timestamp: string,
    selectedUnitId: string,
    selectedUserId: string,
    lmReturnCode: string,
    recipientNameText?: string
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(RETURN_CONSIGNMENTS_MANUAL_OVERRIDE, {
        type: 'RETURN_CONSIGNMENTS_MANUAL_OVERRIDE',
        payload: {
          consignments: consignmentIds,
          timestamp,
          returnCode: lmReturnCode,
          recipientNameText,
          unitId: selectedUnitId,
          userId: selectedUserId
        }
      })
    )

export const manuallyDeviateConsignments =
  (
    consignmentIds: Set<number>,
    timestamp: string,
    selectedUnitId: string,
    selectedUserId: string,
    deviationCode: string
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DEVIATE_CONSIGNMENT_MANUAL_OVERRIDE, {
        type: 'DEVIATE_CONSIGNMENT_MANUAL_OVERRIDE',
        payload: {
          consignments: consignmentIds,
          timestamp,
          deviation: deviationCode,
          unitId: selectedUnitId,
          userId: selectedUserId
        }
      })
    )

export const manuallyCollectConsignments =
  (consignmentIds: Set<number>, timestamp: string, selectedUnitId: string, selectedUserId: string) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(COLLECT_CONSIGNMENTS_MANUAL_OVERRIDE, {
        type: 'COLLECT_CONSIGNMENTS_MANUAL_OVERRIDE',
        payload: {
          consignments: consignmentIds,
          timestamp,
          unitId: selectedUnitId,
          userId: selectedUserId
        }
      })
    )

export const addSortedEventsToConsignments =
  (consignmentIds: Set<number>, timestamp: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(ADD_SORTED_EVENTS, {
        type: ADD_SORTED_EVENTS.name,
        payload: { consignments: consignmentIds, timestamp }
      })
    )

export const markNotArrivedAtDistributingTerminal =
  (consignmentIds: Set<number>, timestamp: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(MARK_NOT_ARRIVED_AT_DISTRIBUTING_TERMINAL, {
        type: MARK_NOT_ARRIVED_AT_DISTRIBUTING_TERMINAL.name,
        payload: { consignmentIds, timestamp }
      })
    )

export const addScannedEventsToConsignments =
  (consignmentIds: Set<number>, timestamp: string, departmentId: number) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(ADD_SCANNED_EVENTS, {
        type: 'ADD_SCANNED_EVENTS',
        payload: { consignments: consignmentIds, timestamp, departmentId }
      })
    )

export const addReadyForPickupEventsToConsignments = (consignmentIds: Set<number>) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_READY_FOR_PICKUP_EVENTS, {
      type: ADD_READY_FOR_PICKUP_EVENTS.name,
      payload: { consignmentIds }
    })
  )

export const addPreAdviceEventToOrders = (orderIds: Set<number>, timestamp: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(PRE_ADVICE_MANUAL_ATTEMPT, {
      type: 'PRE_ADVICE_MANUAL_ATTEMPT',
      payload: { orderIds, timestamp }
    })
  )

export const unresolveDeliveryAddress = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UNRESOLVE_DELIVERY_ADDRESS, {
      type: 'UNRESOLVE_DELIVERY_ADDRESS',
      payload: { orderId }
    })
  )

export const unresolvePickupAddress = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UNRESOLVE_PICKUP_ADDRESS, {
      type: 'UNRESOLVE_PICKUP_ADDRESS',
      payload: { orderId }
    })
  )

export const claimEmail = (email: string) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncPostJson(CLAIM_EMAIL, '/auth/claim-email', { email }))
}

export const requestPwdReset = (email: string) => (dispatch: ThunkDispatch) => {
  return dispatch(api.asyncPostJson(REQUEST_PWD_RESET, '/auth/request-pwd-reset', { email }))
}

export const getAllCustomersByIds = (ids: List<CustomerIdType>) =>
  fetchIfNotPresent(GET_ALL_CUSTOMERS, { query: 'allCustomersByIds', params: { ids } })

export const getDeliveryWindows =
  (customerId: number, postalCode: string, alystraArticleCode: string) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncQuery(GET_DELIVERY_WINDOWS, {
        query: 'deliveryWindows',
        params: { customerId, postalCode, serviceCode: alystraArticleCode }
      })
    )
  }

export const exportLocationListForSlot = (slotId: SlotIdType) =>
  api
    .fetchPost('/exportLocationListForSlot', { params: { slot: slotId } })
    .then((response) => response.blob())
    .then((blob) => saveAs(blob, 'packageLocations.xlsx'))
    .catch((err) => console.error('exportLocationListForSlot', err))

export const exportMultilegReturnsList = (params: AnyData) =>
  api
    .fetchPost('/exportMultilegReturnsList', { params })
    .then((response) => response.blob())
    .then((blob) => saveAs(blob, 'multilegReturnsList.xlsx'))
    .catch((err) => console.error('exportMultilegReturnsList', err))

export const clearSearchSuggestions = (type: string) => (dispatch: ThunkDispatch) =>
  dispatch({
    type: type === AUTOSUGGEST_CUSTOMERS ? CLEAR_SEARCH_CUSTOMERS : CLEAR_SEARCH_ADDRESSES
  })

export const getOrderPrice = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_ORDER_PRICE_DATA, {
      query: 'orderPrice',
      params: payload.toJS()
    })
  ).catch((err) => console.warn('Could not fetch order price:', err))

export const getInvoicedOrderPriceData = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_INVOICED_ORDER_PRICE_DATA, {
      query: 'invoicedOrderPrice',
      params: { orderId }
    })
  )

export const getLatestPriceUpdate = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_LATEST_PRICE_UPDATE, {
      query: 'latestOrderPrice',
      params: { orderId }
    })
  ).catch((err) => console.warn('Could not fetch latest price update:', err))

export const getBillingOrderPrice = (payload: { orderId: number; items: unknown[] }) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_BILLING_ORDER_PRICE_DATA, {
      query: 'billingOrderPrice',
      params: payload
    })
  ).catch((err) => console.warn('Could not fetch billing order price:', err))

export const setPriceExplanationList = (explanations: Array<Record<string, unknown>>) => ({
  type: SET_PRICE_EXPLANATION_LIST,
  explanations
})

export const getMultistopOrderPrice = (groupId: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_MULTISTOP_ORDER_PRICE_DATA, {
      query: 'multiStopOrderPrice',
      params: { groupId }
    })
  )

export const getMultilegOrderPrice = (multilegId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_MULTILEG_ORDER_PRICE_DATA, {
      query: 'multilegOrderPrice',
      params: { multilegId }
    })
  )

export const updateCustomerInformation = (customerId: number, information: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_INFORMATION, {
      type: 'UPDATE_CUSTOMER_INFORMATION',
      payload: {
        customerId,
        information
      }
    })
  )

export const getInvoicingData = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_INVOICING_DATA, {
      query: 'invoicingData',
      params: {
        order: orderId
      }
    })
  )

export const moveOrders =
  (orderIds: List<number>, departmentId: number, consignmentIds: List<ConsignmentIdType>) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(MOVE_ORDERS, {
        type: 'MOVE_ORDERS',
        payload: {
          orderIds,
          destinationDepartmentId: departmentId
        }
      })
    ).then(
      (res) => {
        if (res.ok) {
          dispatch(closeModalAndNotify(i18next.t('consignment.moved')))
          dispatch({ type: CLEAR_ORDER_IDS_ON_MOVED_ORDERS, payload: { orderIds, consignmentIds } })
        }
        return res
      },
      (err) => console.log('moveOrder', err)
    )
export const moveShipment = (orderIds: List<OrderIdType>, departmentId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(MOVE_ORDERS_NEW, {
      type: 'MOVE_ORDERS_NEW',
      payload: {
        orderIds,
        destinationDepartmentId: departmentId
      }
    })
  )

export const getDepartmentsForSameCountry = (departmentId: number, accessLevel: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    fetchIfNotPresent(GET_DEPARTMENTS_IN_SAME_COUNTRY, {
      query: 'departmentsInSameCountry',
      params: {
        departmentId,
        accessLevel
      }
    })
  )

export const createLabel = (orderId: number) => (dispatch: ThunkDispatch) =>
  dispatch(api.asyncCommand(CREATE_LABEL, { type: 'CREATE_LABEL', payload: { orderId } }))

export const getMultipleLabelUrls = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_MULTIPLE_LABEL, {
      query: 'labelUrls',
      params: payload
    })
  )

export const createLabelsForDepartment =
  (
    departmentId: DepartmentIdType,
    date: ISODateString,
    callback: (labelUrl: Map<number, any>) => void,
    createShipmentLabels?: boolean,
    slotId?: SlotIdType
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_LABELS_FOR_DEPARTMENT, {
        type: CREATE_LABELS_FOR_DEPARTMENT.name,
        payload: { departmentId, date, isShipmentLabel: createShipmentLabels, slot: slotId }
      })
    ).then(
      (res) => (res.ok ? callback(Map(res.readBody.labelUrls)) : res),
      (err) => {
        console.log('Error while trying to create labels for the department', err)
      }
    )

export const createMultipleLabel =
  (payload: AnyData, callback: (labelUrl: Map<number, any>) => void) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_MULTIPLE_LABEL, {
        type: 'CREATE_MULTIPLE_LABEL',
        payload
      })
    ).then(
      (res) => (res.ok ? callback(Map(res.readBody.labelUrls)) : res),
      (err) => {
        console.log('Error while trying to create multiple label', err)
      }
    )

export type LabelCallback = (labelUrl: Map<number, any>) => void

export type CreateDeliveryLabels = {
  orderIds: OrderIdType[]
  departmentId?: number
  departmentGroupId?: number
}
export const createDeliveryLabels =
  (payload: CreateDeliveryLabels, callback: LabelCallback) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_DELIVERY_LABELS, {
        type: 'CREATE_DELIVERY_LABELS',
        payload
      })
    ).then(
      (res) => (res.ok ? callback(Map(res.readBody.labelUrls)) : res),
      (err) => {
        console.log('Error while trying to create multiple label', err)
      }
    )

export const createReturnLabels =
  (orderIds: OrderIdType[], departmentId: DepartmentIdType, callback: (labelUrl: Map<number, any>) => void) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CREATE_RETURN_LABELS, {
        type: CREATE_RETURN_LABELS.name,
        payload: { orderIds, departmentId }
      })
    ).then(
      (res) => (res.ok ? callback(Map(res.readBody.labelUrls)) : res),
      (err) => {
        console.log('Error while trying to create multiple label', err)
      }
    )

export const saveCustomerEventEmail =
  (customerId: number, customerEventEmails: CustomerEventEmailFormProps[]) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(SAVE_CUSTOMER_EVENT_EMAIL, {
        type: SAVE_CUSTOMER_EVENT_EMAIL.name,
        payload: {
          customerId,
          customerEventEmails
        }
      })
    )
  }

export const getCustomerEventEmail = (customerId: number) =>
  fetchIfNotPresent(GET_CUSTOMER_EVENT_EMAIL, { query: 'customerEventEmail', params: { customerId } })

export const getOrderDeviations = (id: number) =>
  fetchIfNotPresent(GET_ORDER_DEVIATIONS, { query: 'orderDeviations', params: { customerId: id } })

export const getOrderDeviationsByOrderId = (orderId: number) =>
  fetchIfNotPresent(GET_ORDER_DEVIATIONS, { query: 'orderDeviationsByOrderId', params: { orderId } })

export const createOrderDeviation = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(CREATE_ORDER_DEVIATION, {
      type: 'CREATE_ORDER_DEVIATION',
      payload
    })
  )
}

export const getCustomerSmsText = (id: CustomerIdType) =>
  fetchIfNotPresent(GET_CUSTOMER_SMS_TEXT, { query: 'customerSmsText', params: { customerId: id } })

export const createUpdateCustomerSmsText = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(CREATE_UPDATE_CUSTOMER_SMS_TEXT, {
      type: 'CREATE_UPDATE_CUSTOMER_SMS_TEXT',
      payload
    })
  )
}

export const updateOrderDeviation = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_ORDER_DEVIATION, {
      type: 'UPDATE_ORDER_DEVIATION',
      payload
    })
  )
}

export const deleteOrderDeviation = (id: number) => (dispatch: ThunkDispatch) => {
  dispatch(api.asyncCommand(DELETE_ORDER_DEVIATION, { type: 'DELETE_ORDER_DEVIATION', payload: { id } }))
}

export const setCustomerServiceLevel = (payload: object) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(SET_CUSTOMER_SERVICE_LEVEL, {
      type: 'SET_CUSTOMER_SERVICE_LEVEL',
      payload
    })
  )

export const assignUnitToSlot = (slotId: SlotIdType, unitId: UnitIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ASSIGN_UNIT_TO_SLOT, {
      type: 'ASSIGN_UNIT_TO_SLOT',
      payload: {
        slot: slotId,
        unit: unitId
      }
    })
  )

export const unassignUnitFromSlot = (slotId: SlotIdType, unitId: UnitIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UNASSIGN_UNIT_FROM_SLOT, {
      type: 'UNASSIGN_UNIT_FROM_SLOT',
      payload: {
        slotId,
        unitId
      }
    })
  )

export const assignVehicleToSlot = (slotId: SlotIdType, vehicleId: VehicleIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ASSIGN_VEHICLE_TO_SLOT, {
      type: 'ASSIGN_VEHICLE_TO_SLOT',
      payload: {
        slotId,
        vehicleId
      }
    })
  )
export const unassignVehicleToSlot = (slotId: SlotIdType, vehicleId: VehicleIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UNASSIGN_VEHICLE_FROM_SLOT, {
      type: 'UNASSIGN_VEHICLE_FROM_SLOT',
      payload: {
        slotId,
        vehicleId
      }
    })
  )

export const assignCourierUserToSlot =
  (slotId: SlotIdType, courierUserId: CourierUserId) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(ASSIGN_COURIER_TO_SLOT, {
        type: 'ASSIGN_COURIER_TO_SLOT',
        payload: {
          courierId: courierUserId,
          slotId
        }
      })
    )

export const unassignCourierUserFromSlot =
  (slotId: SlotIdType, courierUserId: CourierUserId) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UNASSIGN_COURIER_FROM_SLOT, {
        type: 'UNASSIGN_COURIER_FROM_SLOT',
        payload: {
          courierId: courierUserId,
          slotId
        }
      })
    )

export const addOrUpdateVehicleType = (orderIds: List<OrderIdType>, vehicleType: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_ORDER_VEHICLE_TYPE, {
      type: 'UPDATE_ORDER_VEHICLE_TYPE',
      payload: {
        orderIds,
        vehicleType
      }
    })
  )

export const sendPrePickupSms = (orderIds: List<OrderIdType>) => (dispatch: ThunkDispatch) =>
  dispatch(api.asyncCommand(SEND_PRE_PICKUP_SMS, { type: 'SEND_PRE_PICKUP_SMS', payload: { orderIds } }))

export const createDepartmentGroupJS = (values: DepartmentGroupProps) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_DEPARTMENT_GROUP, {
      type: 'CREATE_DEPARTMENT_GROUP',
      payload: {
        name: values.name,
        departments: values.departments,
        description: values.description,
        type: values.type
      }
    })
  )

export const createCustomerGroup = (values: CustomerGroup) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_CUSTOMER_GROUP, {
      type: 'CREATE_CUSTOMER_GROUP',
      payload: {
        name: values.get('name'),
        customers: values.get('customers'),
        description: values.get('description')
      }
    })
  )

export const updateCustomerGroup = (values: CustomerGroup) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_GROUP, {
      type: 'UPDATE_CUSTOMER_GROUP',
      payload: {
        customerGroup: values.get('id'),
        name: values.get('name'),
        customers: values.get('customers'),
        description: values.get('description')
      }
    })
  )

export const updateDepartmentGroupJS = (values: DepartmentGroupProps) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_DEPARTMENT_GROUP, {
      type: 'UPDATE_DEPARTMENT_GROUP',
      payload: {
        departmentGroup: values.id,
        name: values.name,
        departments: values.departments,
        description: values.description,
        type: values.type
      }
    })
  )

export const deleteDepartmentGroupRequest = (departmentGroupId: DepartmentGroupIdType) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(DELETE_DEPARTMENT_GROUP, {
      type: 'DELETE_DEPARTMENT_GROUP',
      payload: {
        departmentGroup: departmentGroupId
      }
    })
  )
}

export const deleteCustomerGroup = (customerGroupId: CustomerGroupIdType) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(DELETE_CUSTOMER_GROUP, {
      type: 'DELETE_CUSTOMER_GROUP',
      payload: {
        customerGroup: customerGroupId
      }
    })
  )
}

export const getDepartmentGroups = (excludeEmpty?: boolean) =>
  fetchIfNotPresent(GET_DEPARTMENT_GROUPS, { query: 'departmentGroups', params: { excludeEmpty } })

export const getDepartmentGroupsAlways = (excludeEmpty?: boolean) =>
  fetchIfNotInFlight(GET_DEPARTMENT_GROUPS, { query: 'departmentGroups', params: { excludeEmpty } })

export const getAllDepartmentGroupsWithAdminLevelAccess = () =>
  fetchIfNotInFlight(GET_ALL_DEPARTMENT_GROUPS, {
    query: 'allDepartmentGroupsWithAdminLevelAccess',
    params: {}
  })

export const getCustomerGroups = () => fetchIfNotPresent(GET_CUSTOMER_GROUPS, { query: 'customerGroups', params: {} })

export const getCustomerGroupMembers = (groupId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_CUSTOMER_GROUP_MEMBERS, {
      query: 'customerGroupMembers',
      params: {
        customerGroupId: groupId
      }
    })
  ).then((response) => {
    dispatch(setPageStateValue('customers', fromJS(response.readBody)))
  })

export const getServicesAndVasesTexts = (serviceVasTextType: ServiceVasText) =>
  fetchIfNotPresent(GET_SERVICES_AND_VASES_TEXTS, {
    query: 'servicesAndVasesTexts',
    params: {
      userLanguage: userLanguage(),
      serviceVasTextType
    }
  })

export const getOptimizingIdBySlot = (slotId: number) =>
  fetchIfNotPresent(GET_LATEST_OPTIMIZING_ID_BY_SLOT, {
    query: 'latestOptimizingIdForSlot',
    params: {
      slot: slotId
    }
  })

export const resetOrderPriceInfo = () => (dispatch: ThunkDispatch) =>
  dispatch({
    type: RESET_ORDER_PRICE_INFO
  })

export const getShipmentDetailsFromTracking = (shipmentOrPackageId: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(SEARCH_H2_ORDER, {
      query: 'getShipmentDetailsFromTracking',
      params: {
        shipmentOrPackageId
      }
    })
  )

export const sendManualDelaySms = (orderIds: List<OrderIdType>, smsEndingType: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(SEND_MANUAL_DELAY_SMS, {
      type: SEND_MANUAL_DELAY_SMS.name,
      payload: {
        orderIds,
        smsEndingType
      }
    })
  )

export const sendManualDelaySmsNew =
  (orderIds: OrderIdType[], smsEndingType: string, smsBeginningType: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(SEND_MANUAL_DELAY_SMS_NEW, {
        type: SEND_MANUAL_DELAY_SMS_NEW.name,
        payload: {
          orderIds,
          smsEndingType,
          smsBeginningType
        }
      })
    )

export const markShipmentsDelayed = (orderIds: OrderIdType[], smsBeginningType: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(MARK_SHIPMENTS_DELAYED, {
      type: MARK_SHIPMENTS_DELAYED.name,
      payload: {
        orderIds,
        smsBeginningType
      }
    })
  )

export const markShipmentsRescheduled = (orderIds: OrderIdType[]) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(MARK_SHIPMENTS_RESCHEDULED, {
      type: MARK_SHIPMENTS_RESCHEDULED.name,
      payload: {
        orderIds
      }
    })
  )

export const sendPrePickupSmsNew = (orderIds: OrderIdType[]) => (dispatch: ThunkDispatch) =>
  dispatch(api.asyncCommand(SEND_PRE_PICKUP_SMS_NEW, { type: SEND_PRE_PICKUP_SMS_NEW.name, payload: { orderIds } }))

export function getImportResults(importId: string) {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncQuery(GET_IMPORT_RESULTS, {
        query: 'getImportResults',
        params: { importId }
      })
    )
}

export function getImportStatus() {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncQuery(GET_IMPORT_STATUS, {
        query: 'getImportStatus',
        params: {}
      })
    )
}

export const clearCommandResult = (commandResultType: string) => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: CLEAR_ENTITY_COMMAND_RESULT,
    commandResultType
  })
}

export const clearOrderSearch = () => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: CLEAR_ORDER_SEARCHS
  })
}

export const clearEntities = (entityTypes: MainAccessEntity[]) => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: CLEAR_ENTITIES,
    entityTypes
  })
}

export const clearLocalPlannerEntitiesExcept = () => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: CLEAR_LOCAL_PLANNER_ENTITIES
  })
}
export const clearAllEntities = () => (dispatch: ThunkDispatch) => {
  return dispatch({
    type: CLEAR_ALL_ENTITIES
  })
}

export const getConsignmentEventsWithSentLmStatus = (shipmentId: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    fetchIfNotPresent(EVENTS_WITH_SENT_LM_STATUS, {
      query: 'eventsWithSentLmStatus',
      params: {
        shipmentId
      }
    })
  )

export const getOrdersByOrderIds = (orderIds: List<OrderIdType>) =>
  fetchIfNotPresent(GET_ORDERS_BY_ORDER_IDS, {
    query: 'orders',
    params: { ids: orderIds }
  })

export const updateCustomerSenderName = (payload: CustomerSenderNameProps) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_SENDER_NAME, {
      type: 'UPDATE_CUSTOMER_SENDER_NAME',
      payload
    })
  )
}

export const updateCustomerInvoiceHDOrdersFromDate =
  (payload: CustomerHDOrderInvoiceFromDatePayload) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(UPDATE_CUSTOMER_HD_INVOICING_FROM_DATE, {
        type: 'UPDATE_CUSTOMER_HD_INVOICING_FROM_DATE',
        payload
      })
    )
  }

export const updateCustomerNPSFromDate = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_NPS_FROM_DATE, {
      type: 'UPDATE_CUSTOMER_NPS_FROM_DATE',
      payload
    })
  )
}

export const updateCustomerBillingNumber = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_BILLING_NUMBER, {
      type: 'UPDATE_CUSTOMER_BILLING_NUMBER',
      payload
    })
  )
}

export const updateCustomerBookingPageAccess = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_BOOKING_PAGE_ACCESS, {
      type: UPDATE_CUSTOMER_BOOKING_PAGE_ACCESS.name,
      payload
    })
  )
}

export const updateBrandedTrackingAccess = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_BRANDED_TRACKING_ACCESS, {
      type: UPDATE_BRANDED_TRACKING_ACCESS.name,
      payload
    })
  )
}

export const updateCustomerReturnLastLeg = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_RETURN_LAST_LEG, {
      type: UPDATE_CUSTOMER_RETURN_LAST_LEG.name,
      payload
    })
  )
}

export const updateCustomerUseTerminalAddress =
  (payload: object, callback: () => void) => (dispatch: ThunkDispatch) => {
    dispatch(
      api.asyncCommand(UPDATE_CUSTOMER_USE_TERMINAL_ADDRESS, {
        type: UPDATE_CUSTOMER_USE_TERMINAL_ADDRESS.name,
        payload
      })
    ).then(
      (res) => (res.ok ? callback() : res),
      (err) => console.log('updateCustomerUseTerminalAddress', err)
    )
  }

export const updateCustomerReturnAddress = (payload: object) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_RETURN_ADDRESS, {
      type: UPDATE_CUSTOMER_RETURN_ADDRESS.name,
      payload
    })
  )
}

export const getCustomerReturnAddress = (params: object) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncQuery(GET_CUSTOMER_RETURN_ADDRESS, {
      query: 'customerReturnAddress',
      params
    })
  )
}

export const migrateCustomer =
  (
    customerId: CustomerIdType,
    skipValidation: boolean,
    markAsDeletedAndUnmap: CustomerIdType[],
    callback: () => void,
    errorCallback: (err: any) => void
  ) =>
  (dispatch: ThunkDispatch) => {
    dispatch(
      api.asyncCommand(MIGRATE_CUSTOMER, {
        type: MIGRATE_CUSTOMER.name,
        payload: {
          customerId,
          skipValidation,
          markAsDeletedAndUnmap
        }
      })
    ).then(
      (res) => (res.ok ? callback() : res),
      (err) => errorCallback(err)
    )
  }

export const getCustomerMigrationStatus = (customerId: CustomerIdType) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncQuery(GET_CUSTOMER_MIGRATION_STATUS, {
      query: 'customerMigrationStatus',
      params: {
        customerId
      }
    })
  )
}

export const updateCustomerInvoiceSplit = (payload: object, callback: () => void) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncCommand(UPDATE_CUSTOMER_INVOICE_SPLIT, {
      type: UPDATE_CUSTOMER_INVOICE_SPLIT.name,
      payload
    })
  ).then(
    (res) => (res.ok ? callback() : res),
    (err) => console.log('updateCustomerInvoiceSplit', err)
  )
}

export const getCustomerInvoiceSplit = (params: object) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncQuery(GET_CUSTOMER_INVOICE_SPLIT, {
      query: 'customerInvoiceSplit',
      params
    })
  )
}

export const getCustomerExternalCustomerNumbers = (params: object) => (dispatch: ThunkDispatch) => {
  dispatch(
    api.asyncQuery(GET_CUSTOMER_EXTERNAL_CUSTOMER_NUMBERS, {
      query: 'customerExternalCustomerNumbers',
      params
    })
  )
}

export interface UpdateCustomerScanToCreatePackages {
  customerId: number
  scanToCreatePackages: boolean
}

export const updateCustomerScanToCreatePackages =
  (payload: UpdateCustomerScanToCreatePackages) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(UPDATE_CUSTOMER_SCAN_TO_CREATE_PACKAGES, {
        type: UPDATE_CUSTOMER_SCAN_TO_CREATE_PACKAGES.name,
        payload
      })
    )
  }

export const updateOrderServiceLevel =
  (payload: object, onComplete: (success: boolean) => void, setSubmitting: (flag: boolean) => void) =>
  (dispatch: ThunkDispatch) => {
    setSubmitting(true)
    dispatch(
      api.asyncCommand(UPDATE_ORDER_SERVICE_LEVEL, {
        type: 'UPDATE_ORDER_SERVICE_LEVEL',
        payload
      })
    )
      .then(
        (res) => onComplete(res.ok),
        (err) => {
          console.error('updateOrderServiceLevel', err)
          onComplete(false)
        }
      )
      .finally(() => setSubmitting(false))
  }

export const manuallyPreAdvice = (payload: object) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(MANUAL_PRE_ADVICE, {
      type: 'MANUAL_PRE_ADVICE',
      payload
    })
  )

export const lockOrUnlockPreAdvice =
  (orderIds: OrderIdType[], locked: boolean, sendPreAdvice: boolean) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(LOCK_OR_UNLOCK_PRE_ADVICE, {
        type: LOCK_OR_UNLOCK_PRE_ADVICE.name,
        payload: { orderIds, locked, sendPreAdvice }
      })
    )

export const updateDeliveryTime =
  (orderId: OrderIdType, deliveryTime: DeliveryTime, onComplete: (success: boolean, err?: any) => void = () => {}) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_DELIVERY_TIME, {
        type: 'UPDATE_DELIVERY_TIME',
        payload: {
          orderId,
          deliveryTime: {
            deliveryEarliest: formatAsLocalDate(deliveryTime.earliest),
            deliveryLatest: formatAsLocalDate(deliveryTime.latest)
          }
        }
      })
    ).then(
      (res) => (res.ok ? onComplete(true) : onComplete(false)),
      (err) => {
        console.log('updateDeliveryTime', err)
        onComplete(false, err)
      }
    )

export const updateDeliveryTimes = (orderIds: OrderIdType[], deliveryTime: DeliveryTime) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_DELIVERY_TIMES, {
      type: 'UPDATE_DELIVERY_TIMES',
      payload: {
        orderIds,
        deliveryTime: {
          deliveryEarliest: formatAsLocalDate(deliveryTime.earliest),
          deliveryLatest: formatAsLocalDate(deliveryTime.latest)
        }
      }
    })
  )

export const removeShipmentBookingTimes =
  (orderId: OrderIdType, onComplete: (success: boolean, err?: any) => void = () => {}) =>
  (dispatch: ThunkDispatch) =>
    dispatch(api.asyncCommand(REMOVE_BOOKING_TIMES, { type: REMOVE_BOOKING_TIMES.name, payload: { orderId } })).then(
      (res) => (res.ok ? onComplete(true) : onComplete(false)),
      (err) => {
        console.log('removeShipmentBookingTimes', err)
        onComplete(false, err)
      }
    )

export const quickEditShipment = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(QUICK_EDIT_SHIPMENT, {
      type: QUICK_EDIT_SHIPMENT.name,
      payload
    })
  )

export const createPreAdvicePolicyRequest = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_PRE_ADVICE_POLICY, {
      type: 'CREATE_PRE_ADVICE_POLICY',
      payload
    })
  )

export const deletePreAdvicePolicySet = (preAdvicePolicyId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_PRE_ADVICE_POLICY, { type: 'DELETE_PRE_ADVICE_POLICY', payload: { preAdvicePolicyId } })
  )

export const getPreAdvicePolicies = () =>
  fetchIfNotPresent(GET_PRE_ADVICE_POLICIES, { query: 'preAdvicePolicies', params: {} })

export const getPreAdviceForOrder = (orderId: OrderIdType, user: SessionUser) => {
  return fetchIfNotPresentWithAccess(GET_PRE_ADVICE, { query: 'preAdviceForOrder', params: { orderId } }, user)
}

export const getPreAdviceServicePoliciesRequest = (preAdvicePolicyId: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_PRE_ADVICE_SERVICE_POLICIES, {
      query: 'preAdviceServicePolicies',
      params: { preAdvicePolicyId }
    })
  )

export const createUserRole = (payload: UserRolesPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_ROLE, {
      type: CREATE_ROLE.name,
      payload
    })
  )
export const updateUserRole = (payload: UserRolesPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_ROLE, {
      type: UPDATE_ROLE.name,
      payload
    })
  )
export const deleteUserRole = (roleId: RoleId) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_ROLE, {
      type: DELETE_ROLE.name,
      payload: { roleId }
    })
  )

export const getAllUserRoles = () => fetchIfNotPresent(ROLES, { query: 'roles', params: {} })

export const getAllWhatsThisModals = () =>
  fetchIfNotPresent(GET_ALL_WHATS_THIS_MODALS, { query: 'getAllWhatsThisModals', params: {} })

export const getWhatsThisModalById = (id: WhatsThisModalIdType) =>
  fetchIfNotPresent(GET_WHATS_THIS_MODAL_BY_ID, { query: 'getWhatsThisModalById', params: { id } })

export const getPublishedWhatsThisModals = () =>
  fetchIfNotPresent(GET_PUBLISHED_WHATS_THIS_MODALS, { query: 'getPublishedWhatsThisModals', params: {} })

export const getAllCMSNews = () => fetchIfNotPresent(GET_ALL_CMS_NEWS, { query: 'getAllCMSNews', params: {} })

export const getCMSNewsById = (id: CMSNewsIdType) =>
  fetchIfNotPresent(GET_CMS_NEWS_BY_ID, { query: 'getCMSNewsById', params: { id } })

export const getPublishedCMSNews = () =>
  fetchIfNotPresent(GET_PUBLISHED_CMS_NEWS, { query: 'getPublishedCMSNews', params: {} })

export const getAllBanners = () => fetchIfNotPresent(GET_ALL_BANNERS, { query: 'getAllBanners', params: {} })
export const getPublishedBanners = () =>
  fetchIfNotPresent(GET_PUBLISHED_BANNERS, { query: 'getPublishedBanners', params: {} })

export const getBannerById = (id: BannerIdType) =>
  fetchIfNotPresent(GET_BANNER_BY_ID, { query: 'getBannerById', params: { id } })

export const getLoginPageBanner = () =>
  fetchIfNotPresent(GET_LOGIN_PAGE_BANNER, { query: 'getLoginPageBanner', params: {} })

export const validateBannerURL = (pageURL: string, id?: BannerIdType) =>
  fetchEvenIfPresent(VALIDATE_BANNER_URL, { query: 'validateBannerURL', params: { pageURL, id } })

export const createBanner = (payload: CreateBannerPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_BANNER, {
      type: CREATE_BANNER.name,
      payload
    })
  )
export const updateBanner = (payload: UpdateBannerPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_BANNER, {
      type: UPDATE_BANNER.name,
      payload
    })
  )
export const deleteBanner = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_BANNER, {
      type: DELETE_BANNER.name,
      payload: { id }
    })
  )
export const createWhatsThisModal = (payload: CreateWhatsThisModalPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_WHATS_THIS_MODAL, {
      type: CREATE_WHATS_THIS_MODAL.name,
      payload
    })
  )
export const updateWhatsThisModal = (payload: UpdateWhatsThisModalPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_WHATS_THIS_MODAL, {
      type: UPDATE_WHATS_THIS_MODAL.name,
      payload
    })
  )
export const deleteWhatsThisModal = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_WHATS_THIS_MODAL, {
      type: DELETE_WHATS_THIS_MODAL.name,
      payload: { id }
    })
  )

export const createCMSNews = (payload: CreateCMSNewsPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_CMS_NEWS, {
      type: CREATE_CMS_NEWS.name,
      payload
    })
  )
export const updateCMSNews = (payload: UpdateCMSNewsPayload) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_CMS_NEWS, {
      type: UPDATE_CMS_NEWS.name,
      payload
    })
  )
export const deleteCMSNews = (id: number) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_CMS_NEWS, {
      type: DELETE_CMS_NEWS.name,
      payload: { id }
    })
  )

export const updateCustomer = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(UPDATE_CUSTOMER, {
      type: UPDATE_CUSTOMER.name,
      payload
    })
  )

export const createCustomer = (payload: AnyData) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_CUSTOMER, {
      type: CREATE_CUSTOMER.name,
      payload
    })
  )

export const disableJob = (jobName: string, onAccessDenied: () => void) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DISABLE_JOB, {
      type: DISABLE_JOB.name,
      payload: {
        jobName
      }
    })
  ).catch((reason) => {
    if (reason.status === 403) {
      onAccessDenied()
    }
  })

export const enableJob = (jobName: string, onAccessDenied: () => void) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ENABLE_JOB, {
      type: ENABLE_JOB.name,
      payload: {
        jobName
      }
    })
  ).catch((reason) => {
    if (reason.status === 403) {
      onAccessDenied()
    }
  })

export const getSuggestedUnitsForLocation =
  (departmentId: DepartmentIdType, lat: number | null, lng: number | null, dispatchDate: DateTime) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      fetchIfNotPresent(GET_SUGGESTED_UNITS_FOR_LOCATION, {
        query: 'suggestedUnitsForLocation',
        params: { departmentId, lat, lng, dispatchDate: dispatchDate.toISODate() }
      })
    )

export const getSuggestedUnitsForOrder =
  (
    departmentId: DepartmentIdType,
    orderId: OrderIdType,
    suggestionType: UnitSuggestionType,
    additionalTimeWindowMinutes: number
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      fetchIfNotPresent(suggestionType === 'pickup' ? GET_SUGGESTED_UNITS_ON_PICKUP : GET_SUGGESTED_UNITS_ON_DELIVERY, {
        query: 'suggestedUnitsForOrder',
        params: { departmentId, orderId, suggestionType, additionalTimeWindowMinutes }
      })
    )

export const createBillingOrder = (billingOrder: BillingOrder) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_BILLING_ORDER, {
      type: 'CREATE_BILLING_ORDER',
      payload: {
        ...{
          ...billingOrder,
          deliveryDate: billingOrder.deliveryTimeEarliest,
          items: billingOrder.items.map((item) => ({
            specification: item.specification != '' ? item.specification : undefined,
            quantity: item.quantity != '' ? item.quantity : undefined,
            customerAmount: item.customerAmount != '' ? item.customerAmount : undefined,
            carrierAmount: item.carrierAmount != '' ? item.carrierAmount : undefined,
            creditLineId: item.lineId != '' ? item.lineId : undefined,
            articleCode: item.articleCode
          }))
        }
      }
    })
  )

export const getCustomersWithTimeMatrix = () => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_CUSTOMERS_WITH_TIME_MATRIX, {
      query: 'getCustomersWithTimeMatrix',
      params: {}
    })
  )

export const toggleShowCustomerPrice =
  (alystraCustomerId: string, alystraSubcustomer?: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(TOGGLE_SHOW_CUSTOMER_PRICE, {
        type: TOGGLE_SHOW_CUSTOMER_PRICE.name,
        payload: { alystraCustomerId, alystraSubcustomer }
      })
    )

export const deleteCustomerTimeMatrix =
  (alystraCustomerId: string, alystraSubcustomer?: string) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DELETE_TIME_MATRIX, {
        type: DELETE_TIME_MATRIX.name,
        payload: { alystraCustomerId, alystraSubcustomer }
      })
    )

export const localizedAbbreviatedNumber = (value?: number) => (value ? abbreviateNumber(value, userLanguage()) : '0')

export const createWaybillsDispatch = (orderIds: Set<number>) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_WAYBILLS_REQUEST, {
      type: CREATE_WAYBILLS_REQUEST.name,
      payload: {
        orderIds
      }
    })
  )

export const getWaybills = (waybillsRequestId: number) =>
  fetchEvenIfPresent(GET_WAYBILLS, { query: 'waybills', params: { waybillsRequestId } })

export const getDeliveryNotes = (orderIds: OrderIdType[]) =>
  fetchEvenIfPresent(GET_DELIVERY_NOTES, { query: 'deliveryNotes', params: { orderIds } })

export const createMultilegReturn = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_MULTILEG_RETURN, {
      type: 'CREATE_MULTILEG_RETURN',
      payload: {
        orderId
      }
    })
  )
export const createMultilegReturns = (orderIds: OrderIdType[]) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(CREATE_MULTILEG_RETURNS, {
      type: 'CREATE_MULTILEG_RETURNS',
      payload: {
        orderIds
      }
    })
  )

export const getOrderReturnDetails = (orderId: OrderIdType) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_ORDER_RETURN_DETAILS, {
      query: 'getOrderReturnDetails',
      params: {
        orderId
      }
    })
  )

export const updateMultistopPriceCorrection =
  (
    groupId: string,
    correctedArticlePrices: List<CorrectedArticlePrice>,
    calculatedArticlePrices: List<IPricedArticle>,
    allowIncompletePrice?: boolean
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_MULTISTOP_PRICE_CORRECTION, {
        type: 'UPDATE_MULTISTOP_PRICE_CORRECTION',
        payload: {
          groupId,
          allowIncompletePrice,
          correctedArticlePrices: correctedArticlePrices.map((it) => ({
            articleCode: it.get('articleCode'),
            customerPrice: it.get('customerPrice'),
            resourcePrice: it.get('resourcePrice')
          })),
          calculatedArticlePrices: calculatedArticlePrices.map((it) => ({
            articleCode: it.get('articleCode'),
            articleLabel: it.get('articleLabel'),
            customerPrice: it.get('customerPrice'),
            resourcePrice: it.get('resourcePrice')
          }))
        }
      })
    )

export const updateMultilegPriceCorrection =
  (
    multilegId: number,
    correctedArticlePrices: List<CorrectedArticlePrice>,
    calculatedArticlePrices: List<IPricedArticle>,
    allowIncompletePrice?: boolean
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(UPDATE_MULTILEG_PRICE_CORRECTION, {
        type: 'UPDATE_MULTILEG_PRICE_CORRECTION',
        payload: {
          multilegId,
          allowIncompletePrice,
          correctedArticlePrices: correctedArticlePrices.map((it) => ({
            articleCode: it.get('articleCode'),
            customerPrice: it.get('customerPrice'),
            resourcePrice: it.get('resourcePrice'),
            transportLegIndex: it.get('transportLegIndex')
          })),
          calculatedArticlePrices: calculatedArticlePrices.map((it) => ({
            articleCode: it.get('articleCode'),
            articleLabel: it.get('articleLabel'),
            customerPrice: it.get('customerPrice'),
            resourcePrice: it.get('resourcePrice'),
            transportLegIndex: it.get('transportLegIndex')
          }))
        }
      })
    )

export const getArticlesInGroup = (groupCode: string) =>
  fetchIfNotPresent(GET_ARTICLES_IN_GROUP, {
    query: 'articlesInArticleGroup',
    params: { groupCode }
  })

export const getCustomerCurrency = (customerNumber: string, departmentName?: string) =>
  fetchIfNotPresent(GET_CUSTOMER_CURRENCY, {
    query: 'customerCurrency',
    params: { customerNumber, departmentName }
  })

export const getVendor = (vendorNumber: number) =>
  fetchIfNotPresent(GET_VENDOR, {
    query: 'vendor',
    params: { vendorNumber }
  })

export const connectUnitsToVendor =
  (
    vendorSiteId: number,
    unitWithDepartmentList: Array<{ unitId: number; departmentId: number }>,
    disconnectedUnits: UnitIdType[]
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(CONNECT_UNITS_TO_VENDOR_SITE, {
        type: 'CONNECT_UNITS_TO_VENDOR_SITE',
        payload: {
          vendorSiteId,
          unitWithDepartmentList,
          disconnectedUnits
        }
      })
    )

export const searchProductionTimeWindows = (params: SearchProductionTimeWindowsParams) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(SEARCH_PRODUCTION_TIME_WINDOWS, {
      query: 'searchProductionTimeWindows',
      params
    })
  )

export const addNewProductionTimeWindow = (payload: ProductionTimeWindowForm) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(ADD_NEW_PRODUCTION_TIME_WINDOW, {
      type: 'ADD_NEW_PRODUCTION_TIME_WINDOW',
      payload
    })
  )

export const editProductionTimeWindow = (payload: EditProductionTimeWindowFormValues) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(EDIT_PRODUCTION_TIME_WINDOW, {
      type: 'EDIT_PRODUCTION_TIME_WINDOW',
      payload
    })
  )

export const deleteProductionTimeWindow = (recipientId: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncCommand(DELETE_PRODUCTION_TIME_WINDOW, {
      type: 'DELETE_PRODUCTION_TIME_WINDOW',
      payload: {
        recipientId
      }
    })
  )

export const getConsignmentsInSameLoadCarrier = (loadCarrierId?: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_CONSIGNMENTS_IN_SAME_LOAD_CARRIER, {
      query: 'consignmentsInSameLoadCarrier',
      params: { loadCarrierId }
    })
  )

export const getRecurringOrderResult = (departmentId: number, date: string) => (dispatch: ThunkDispatch) =>
  dispatch(
    api.asyncQuery(GET_RECURRING_ORDER_EXECUTIONS, {
      query: 'recurringOrderExecutions',
      params: { department: departmentId, date }
    })
  )

export function resetRecurringOrder(departmentId: number, date: string) {
  return (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(RESET_RECURRING_ORDER, {
        type: 'RESET_RECURRING_ORDER',
        payload: { departmentId, date }
      })
    )
}

export const getOrderCorrectionsWithConsignments =
  (departmentId: number, fromDate: string, toDate: string): ThunkResult<Promise<Response>> =>
  (dispatch) => {
    const params = {
      departmentId,
      fromQueryDate: fromDate,
      toQueryDate: toDate
    }

    return dispatch(api.asyncQuery(GET_ORDER_CORRECTIONS, { query: 'orderCorrectionsWithConsignments', params }))
  }

export const upsertTemplateRoutes = (templateRoute: TemplateRoute) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(UPSERT_TEMPLATE_ROUTE, {
      type: UPSERT_TEMPLATE_ROUTE.name,
      payload: templateRoute
    })
  )
}

export const triggerTemplateRouteExecution =
  (departmentId: number, date: string, templateRouteIds: number[]) => (dispatch: ThunkDispatch) => {
    return dispatch(
      api.asyncCommand(EXECUTE_RECURRING_ROUTES, {
        type: EXECUTE_RECURRING_ROUTES.name,
        payload: { departmentId, date, templateRouteIds }
      })
    )
  }

export const rerollOutTemplateRoutes =
  (departmentId: number, date: string, templateRouteIds: number[]) => (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(REROLL_OUT_RECURRING_ROUTES, {
        type: REROLL_OUT_RECURRING_ROUTES.name,
        payload: { departmentId, date, templateRouteIds }
      })
    )

export const dismissRecurringRouteProblems =
  (executionShipmentIds: number[], executionPlannedStopIds: number[], dismissed: boolean) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(DISMISS_RECURRING_ROUTE_PROBLEMS, {
        type: DISMISS_RECURRING_ROUTE_PROBLEMS.name,
        payload: { executionShipmentIds, executionPlannedStopIds, dismissed }
      })
    )

export const deleteTemplateRoute = (id: number) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(DELETE_TEMPLATE_ROUTE, {
      type: DELETE_TEMPLATE_ROUTE.name,
      payload: { templateRouteId: id }
    })
  )
}

export const deleteTemplateRoutes = (ids: number[]) => (dispatch: ThunkDispatch) => {
  return dispatch(
    api.asyncCommand(DELETE_TEMPLATE_ROUTES, {
      type: DELETE_TEMPLATE_ROUTES.name,
      payload: { templateRouteIds: ids }
    })
  )
}

export const moveTemplateShipments =
  (
    shipmentIds: Immutable.Set<number> | undefined,
    plannedStopIds: Immutable.Set<number> | undefined,
    templateRouteId: number
  ) =>
  (dispatch: ThunkDispatch) =>
    dispatch(
      api.asyncCommand(MOVE_TEMPLATE_SHIPMENTS_AND_STOPS, {
        type: MOVE_TEMPLATE_SHIPMENTS_AND_STOPS.name,
        payload: {
          shipmentIds,
          plannedStopIds,
          templateRouteId
        }
      })
    )
